((window.theme = window.theme || {}),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var s = 0, r = e.options.length; s < r; s++) {
      var i = e.options[s];
      if (t == i.value || t == i.innerHTML) return (e.selectedIndex = s);
    }
  }),
  (Shopify.addListener = function (e, t, s) {
    e.addEventListener ? e.addEventListener(t, s, !1) : e.attachEvent("on" + t, s);
  }),
  (Shopify.postLink = function (e, t) {
    var s,
      r = (t = t || {}).method || "post",
      i = t.parameters || {},
      a = document.createElement("form");
    for (s in (a.setAttribute("method", r), a.setAttribute("action", e), i)) {
      var o = document.createElement("input");
      (o.setAttribute("type", "hidden"), o.setAttribute("name", s), o.setAttribute("value", i[s]), a.appendChild(o));
    }
    (document.body.appendChild(a), a.submit(), document.body.removeChild(a));
  }),
  (Shopify.CountryProvinceSelector = function (e, t, s) {
    ((this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(s.hideElement || t)),
      Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler());
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
        s = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), s && 0 == s.length)) this.provinceContainer.style.display = "none";
      else {
        for (var r, i = 0; i < s.length; i++)
          (((r = document.createElement("option")).value = s[i][0]),
            (r.innerHTML = s[i][1]),
            this.provinceEl.appendChild(r));
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild;) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var s = 0;
      for (t.length; s < t.length; s++) {
        var r = document.createElement("option");
        ((r.value = t[s]), (r.innerHTML = t[s]), e.appendChild(r));
      }
    },
  }),
  (theme.config = {
    mediaQueries: {
      landscapeAll: "screen and (orientation: landscape)",
      landscape: "screen and (orientation: landscape), screen and (min-width: 48rem)",
      belowTablet: "screen and (max-width: 47.99rem)",
      tablet: "screen and (min-width: 48rem)",
      belowLaptop: "screen and (max-width: 63.99rem)",
      laptop: "screen and (min-width: 64rem)",
      belowDesktop: "screen and (max-width: 64rem)",
      desktop: "screen and (min-width: 64.01rem)",
      belowWidescreen: "screen and (max-width: 79.99rem)",
      widescreen: "screen and (min-width: 80rem)",
      belowExtrawide: "screen and (max-width: 89.99rem)",
      extrawide: "screen and (min-width: 90rem)",
    },
    money: {
      format: `${window.currency.symbol || "$"}{{amount}}`,
      currencySymbols: {
        USD: "$",
        CAD: "$",
        EUR: "€",
        CRC: "₡",
        GBP: "£",
        ILS: "₪",
        INR: "₹",
        JPY: "¥",
        KRW: "₩",
        NGN: "₦",
        PHP: "₱",
        PLN: "zł",
        PYG: "₲",
        THB: "฿",
        UAH: "₴",
        VND: "₫",
      },
    },
    upsellLimit: 6,
  }),
  (theme.utils = {
    subscriptions: {
      subscribers: {},
      subscribe(e, t) {
        return (
          void 0 === theme.utils.subscriptions.subscribers[e] && (theme.utils.subscriptions.subscribers[e] = []),
          (theme.utils.subscriptions.subscribers[e] = [...theme.utils.subscriptions.subscribers[e], t]),
          function () {
            theme.utils.subscriptions.subscribers[e] = theme.utils.subscriptions.subscribers[e].filter((e) => e !== t);
          }
        );
      },
      publish(e, t) {
        theme.utils.subscriptions.subscribers[e] &&
          theme.utils.subscriptions.subscribers[e].forEach((e) => {
            e(t);
          });
      },
    },
    a11y: {
      getFocusableElements(e) {
        return Array.from(
          e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
          ),
        );
      },
      _trapFocusHandlers: {},
      trapFocus(t, e = t) {
        var s = theme.utils.a11y.getFocusableElements(t),
          r = s[0],
          i = s[s.length - 1];
        (theme.utils.a11y.removeTrapFocus(),
          (theme.utils.a11y._trapFocusHandlers.focusin = (e) => {
            (e.target !== t && e.target !== i && e.target !== r) ||
              document.addEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown);
          }),
          (theme.utils.a11y._trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown);
          }),
          (theme.utils.a11y._trapFocusHandlers.keydown = function (e) {
            "TAB" === e.code.toUpperCase() &&
              (e.target !== i || e.shiftKey || (e.preventDefault(), r.focus()), e.target === t || e.target === r) &&
              e.shiftKey &&
              (e.preventDefault(), i.focus());
          }),
          document.addEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout),
          document.addEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin),
          e.focus());
      },
      removeTrapFocus(e = null) {
        (document.removeEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin),
          document.removeEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout),
          document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown),
          e && e.focus());
      },
    },
    prepareTransition(e) {
      e.addEventListener("transitionend", () => {
        e.classList.remove("is-transitioning");
      });
      let t = 0,
        s = getComputedStyle(e);
      ([
        "transition-duration",
        "-moz-transition-duration",
        "-webkit-transition-duration",
        "-o-transition-duration",
      ].forEach((e) => (t = t || parseFloat(s.getPropertyValue(e)))),
        0 != t && (e.classList.add("is-transitioning"), e.offsetWidth));
    },
    defaultTo: function (e, t) {
      return null == e || e != e ? t : e;
    },
    stripProductMediaColorTag(e) {
      if (!e) return "";
      const t = String(e);
      const s = t.lastIndexOf("#color_");
      return s === -1 ? t : t.slice(0, s).trim();
    },
    formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var s = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        c = t || theme.config.money.format;
      function r(e, t, s, r) {
        if (
          ((t = theme.utils.defaultTo(t, 2)),
            (s = theme.utils.defaultTo(s, ",")),
            (r = theme.utils.defaultTo(r, ".")),
            isNaN(e) || null == e)
        )
          return 0;
        let i = (e = (e / 100).toFixed(t)).split("."),
          a = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s),
          o = i[1] ? r + i[1] : "";
        return a + (o = "no_trailing_zeros" == c.match(n)[1] && ".00" == o ? "" : o);
      }
      switch (c.match(n)[1]) {
        case "amount":
          s = r(e, 2);
          break;
        case "amount_no_decimals":
          s = r(e, 0);
          break;
        case "amount_with_space_separator":
          s = r(e, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = r(e, 0, ",", ".");
          break;
        case "amount_no_decimals_with_space_separator":
          s = r(e, 0, " ");
          break;
        case "no_trailing_zeros":
          s = r(e, 2);
      }
      return c.replace(n, s);
    },
    serializeForm: (e) => {
      var t,
        s = {},
        r = new FormData(e);
      for (t of r.keys()) {
        var i = /(?:^(properties\[))(.*?)(?:\]$)/;
        i.test(t) ? ((s.properties = s.properties || {}), (s.properties[i.exec(t)[2]] = r.get(t))) : (s[t] = r.get(t));
      }
      return JSON.stringify(s);
    },
    debounce(t, s) {
      let r;
      return (...e) => {
        (clearTimeout(r), (r = setTimeout(() => t.apply(this, e), s)));
      };
    },
    getSiblings(e, t) {
      var s,
        r = [];
      let i;
      for (s of (i = t ? e.parentNode.querySelectorAll(":scope > " + t) : e.parentNode.children)) s !== e && r.push(s);
      return r;
    },
    refreshElements(e, t, s) {
      e.forEach((e) => {
        let a = t.querySelectorAll(e);
        s.querySelectorAll(e).forEach((e, t) => {
          var s, r, i;
          a[t]
            ? null != e.getAttribute("js-accordion-item")
              ? ((s = e.querySelector("[js-accordion-header]").getAttribute("aria-expanded")),
                (r = e.querySelector("[js-accordion-content]").getAttribute("aria-hidden")),
                (i = a[t]).querySelector("[js-accordion-header]").setAttribute("aria-expanded", s),
                i.querySelector("[js-accordion-content]").setAttribute("aria-hidden", r),
                (e.innerHTML = i.innerHTML))
              : (e.innerHTML = a[t].innerHTML)
            : e.remove();
        });
      });
    },
    handleize(e) {
      return e
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    },
    getCookie(e) {
      for (var t = e + "=", s = decodeURIComponent(document.cookie).split(";"), r = 0; r < s.length; r++) {
        for (var i = s[r]; " " == i.charAt(0);) i = i.substring(1);
        if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
      }
      return "";
    },
    setCookie(e, t, s) {
      var r = new Date(),
        s = (r.setTime(r.getTime() + 24 * s * 60 * 60 * 1e3), "expires=" + r.toUTCString());
      document.cookie = e + "=" + t + ";" + s + ";path=/";
    },
    /**
     * PDP: sync color swatch radios, labels, ATC, % OFF badge from ProductJSON.
     * Runs on first load (s-product connectedCallback) and after size links replace #MainContent (innerHTML does not re-run section scripts).
     */
    initPdpVariantFormSync(rootScope) {
      const scope = rootScope || document;
      let form = scope.querySelector ? scope.querySelector("form[js-product-form]") : null;
      if (!form) {
        form = document.querySelector("form[js-product-form]");
      }
      if (!form) return;
      if (form.getAttribute("data-pdp-variant-form-sync") === "true") return;
      form.setAttribute("data-pdp-variant-form-sync", "true");

      const productRoot = form.closest("s-product") || document.querySelector("s-product");
      const productJsonId =
        productRoot && productRoot.dataset && productRoot.dataset.productJsonId
          ? productRoot.dataset.productJsonId
          : "ProductJSON";
      const productJsonEl = document.getElementById(productJsonId) || document.getElementById("ProductJSON");
      if (!productJsonEl) return;

      let product;
      try {
        product = JSON.parse(productJsonEl.textContent);
      } catch {
        return;
      }

      function getCurrentSizeLabel() {
        if (typeof current_size !== "undefined") return current_size;
        const activeSizeLink = document.querySelector(".sizes-swatches a.active");
        return activeSizeLink ? activeSizeLink.textContent.replace(/\s+/g, " ").trim() : "";
      }

      function getVariantIdField() {
        return form.querySelector('[name="id"]');
      }

      function syncPercentOffBadge(variant) {
        if (!variant) return;
        const carouselSuffix =
          productRoot && productRoot.dataset && productRoot.dataset.carouselIdSuffix
            ? productRoot.dataset.carouselIdSuffix
            : "";
        const mainCarousel = document.getElementById("ProductMainImages-" + product.id + carouselSuffix);
        if (!mainCarousel) return;
        const badge = mainCarousel.querySelector("[js-badge-percent-off]");
        const badgeTextElement = mainCarousel.querySelector("[js-badge-percent-off-text]");
        if (!badge) return;

        let variantPriceMapForBadge = {};
        let variantPriceMapBadgeEl = null;
        if (productRoot && productRoot.querySelector) {
          variantPriceMapBadgeEl =
            productRoot.querySelector("#ProductVariantPriceMap") ||
            productRoot.querySelector('[id^="ProductVariantPriceMap-qv-"]');
        }
        if (!variantPriceMapBadgeEl) {
          variantPriceMapBadgeEl = document.getElementById("ProductVariantPriceMap");
        }
        if (variantPriceMapBadgeEl) {
          try {
            variantPriceMapForBadge = JSON.parse(variantPriceMapBadgeEl.textContent || "{}");
          } catch (_parseError) {
            variantPriceMapForBadge = {};
          }
        }
        const mappedBadgeRow = variantPriceMapForBadge[String(variant.id)] || null;
        if (
          mappedBadgeRow &&
          typeof mappedBadgeRow.metafield_discount_percent === "number" &&
          mappedBadgeRow.metafield_discount_percent > 0
        ) {
          badge.classList.remove("hidden");
          if (badgeTextElement) {
            badgeTextElement.textContent = mappedBadgeRow.metafield_discount_percent + "% OFF";
          }
          return;
        }
        const effCompareAtForBadge =
          mappedBadgeRow && typeof mappedBadgeRow.compare_at_price === "number"
            ? mappedBadgeRow.compare_at_price
            : variant.compare_at_price;
        const effPriceForBadge =
          mappedBadgeRow && typeof mappedBadgeRow.price === "number" ? mappedBadgeRow.price : variant.price;
        function percentOffFromSnippetPrices() {
          const c = Number(effCompareAtForBadge);
          const p = Number(effPriceForBadge);
          if (!c || c <= p) return null;
          return Math.floor((100 * (c - p)) / c);
        }

        const rulesScript = mainCarousel.querySelector("script.js-collection-promo-rules");
        let collectionPromoPercentFromJsonRules = null;
        if (rulesScript && rulesScript.textContent.trim()) {
          try {
            const campaignPromoRules = JSON.parse(rulesScript.textContent.trim());
            if (Array.isArray(campaignPromoRules)) {
              const collectionIdsAttribute = badge.getAttribute("data-product-collection-ids") || "";
              const productCollectionIdSet = new Set(
                collectionIdsAttribute
                  .split(",")
                  .map((idPart) => idPart.trim())
                  .filter(Boolean)
                  .map((idPart) => Number(idPart)),
              );
              const productIdNumber = Number(product.id);
              const variantIdNumber = Number(variant.id);
              let highestMatchingPercent = 0;
              for (let ruleIndex = 0; ruleIndex < campaignPromoRules.length; ruleIndex++) {
                const campaignPromoRule = campaignPromoRules[ruleIndex];
                const rulePercentage = Number(campaignPromoRule.percentage) || 0;
                if (rulePercentage <= 0) continue;
                let campaignRuleMatches = false;
                if (
                  campaignPromoRule.collectionId != null &&
                  campaignPromoRule.collectionId !== "" &&
                  productCollectionIdSet.has(Number(campaignPromoRule.collectionId))
                ) {
                  campaignRuleMatches = true;
                }
                if (
                  !campaignRuleMatches &&
                  Array.isArray(campaignPromoRule.productIds) &&
                  campaignPromoRule.productIds.includes(productIdNumber)
                ) {
                  campaignRuleMatches = true;
                }
                if (
                  !campaignRuleMatches &&
                  Array.isArray(campaignPromoRule.variantIds) &&
                  campaignPromoRule.variantIds.includes(variantIdNumber)
                ) {
                  campaignRuleMatches = true;
                }
                if (campaignRuleMatches && rulePercentage > highestMatchingPercent) {
                  highestMatchingPercent = rulePercentage;
                }
              }
              collectionPromoPercentFromJsonRules = highestMatchingPercent;
            }
          } catch (_parseError) {
            collectionPromoPercentFromJsonRules = null;
          }
        }

        if (collectionPromoPercentFromJsonRules !== null) {
          if (collectionPromoPercentFromJsonRules > 0) {
            badge.classList.remove("hidden");
            const pctFromSnippet = percentOffFromSnippetPrices();
            const pct =
              pctFromSnippet != null ? pctFromSnippet : collectionPromoPercentFromJsonRules;
            if (badgeTextElement) badgeTextElement.textContent = pct + "% OFF";
            return;
          }
        } else {
          const collectionPromoMaximumPercent = parseInt(badge.getAttribute("data-collection-promo-max") || "0", 10);
          const percentOffSource = badge.getAttribute("data-percent-off-source") || "";
          if (collectionPromoMaximumPercent > 0 && percentOffSource === "collection") {
            badge.classList.remove("hidden");
            const pctFromSnippet = percentOffFromSnippetPrices();
            const pct = pctFromSnippet != null ? pctFromSnippet : collectionPromoMaximumPercent;
            if (badgeTextElement) badgeTextElement.textContent = pct + "% OFF";
            return;
          }
        }

        const compareAtPercentOffBadgeEnabled = badge.getAttribute("data-compare-at-percent-off-badge-enabled") === "true";
        if (!compareAtPercentOffBadgeEnabled) {
          badge.classList.add("hidden");
          if (badgeTextElement) badgeTextElement.textContent = "";
          return;
        }

        const compareAtPrice = Number(effCompareAtForBadge);
        const variantPrice = Number(effPriceForBadge);
        if (!compareAtPrice || compareAtPrice <= variantPrice) {
          badge.classList.add("hidden");
          if (badgeTextElement) badgeTextElement.textContent = "";
          return;
        }
        const discountAmount = compareAtPrice - variantPrice;
        const discountPercentFromCompareAt = Math.floor((100 * discountAmount) / compareAtPrice);
        if (badgeTextElement) badgeTextElement.textContent = discountPercentFromCompareAt + "% OFF";
        badge.classList.remove("hidden");
      }

      function syncFromVariantId(variantId) {
        const variant = product.variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        const colorLabel = variant.option1 || "";
        if (productRoot) {
          productRoot.querySelectorAll("[js-color-label-custom]").forEach((el) => {
            if (!el.closest("quick-add")) el.textContent = colorLabel;
          });
        }
        form.querySelectorAll("[js-color-label]").forEach((el) => {
          if (!el.closest("quick-add")) el.textContent = colorLabel;
        });

        const sizeLabel = getCurrentSizeLabel();
        document.querySelectorAll("[js-size-label-custom]").forEach((el) => {
          el.textContent = sizeLabel;
        });

        form.querySelectorAll(".product__swatch-input[data-variant-id]").forEach((radio) => {
          if (radio.closest("quick-add")) return;
          const isMatch = String(radio.getAttribute("data-variant-id")) === String(variantId);
          radio.checked = isMatch;
          const label = form.querySelector('label[for="' + radio.id + '"]');
          if (label) label.classList.toggle("active", isMatch);
        });

        const variantEventTarget =
          productRoot && productRoot.tagName && productRoot.tagName.toLowerCase() === "s-product"
            ? productRoot
            : document.querySelector("s-product");
        if (variantEventTarget) {
          variantEventTarget.dispatchEvent(
            new CustomEvent("variant:change", {
              detail: { variant, priceChange: true },
              bubbles: true,
            }),
          );
        }

        const atcTextEl = document.querySelector("[data-atc-text]");
        if (atcTextEl) {
          atcTextEl.textContent = variant.available ? "Add to Cart" : "Sold Out";
          const atcButton = atcTextEl.closest("button");
          if (atcButton) atcButton.disabled = !variant.available;
        }
        const addToCartBtn = form.querySelector("button[js-add-to-cart]");
        if (addToCartBtn) addToCartBtn.disabled = !variant.available;
      }

      function setVariantId(variantId) {
        const field = getVariantIdField();
        if (!field) return;
        field.value = String(variantId);
        field.dispatchEvent(new Event("change", { bubbles: true }));
        syncFromVariantId(variantId);
      }

      form.addEventListener("change", (event) => {
        if (event.target.name === "id" && form.contains(event.target)) {
          syncFromVariantId(event.target.value);
        } else if (
          form.contains(event.target) &&
          event.target.classList.contains("product__swatch-input") &&
          event.target.getAttribute("data-variant-id")
        ) {
          setVariantId(event.target.getAttribute("data-variant-id"));
        }
      });

      if (productRoot) {
        productRoot.addEventListener("variant:change", (event) => {
          if (event.detail && event.detail.variant) {
            syncPercentOffBadge(event.detail.variant);
          }
        });
      }

      const initialField = getVariantIdField();
      if (initialField && initialField.value) {
        syncFromVariantId(initialField.value);
      }
    },
  }));
class FocusableWidget extends HTMLElement {
  constructor(e = {}) {
    if ((super(), !e.name)) throw new Error(`Focusable Widget(${e.name}) must have a name`);
    if (!this.id) throw new Error(e.name + " must have an id");
    if (!e.background) throw new Error(`Focusable Widget(${e.name}) must have a background`);
    ((this._clientConfig = e), this._init(e));
  }
  open = () => {
    if (!this._isOpen) return (this._closeFocusableWidgets(), this.toggle());
  };
  close = () => {
    if (this._isOpen) return this.toggle();
  };
  toggle = () => (
    theme.utils.prepareTransition(this),
    this._toggleClasses(),
    this._toggleAccessibilityAttributes(),
    this._isOpen
      ? (theme.utils.a11y.removeTrapFocus(this),
        this._unbindEvents(),
        this._dispatchEvents(this._events.close, ["close"]))
      : (theme.utils.a11y.trapFocus(this), this._bindEvents(), this._dispatchEvents(this._events.open, ["open"])),
    (this._isOpen = !this._isOpen),
    this
  );
  reinitWidget = () => {
    this._init(this._clientConfig);
  };
  get isOpen() {
    return this._isOpen;
  }
  _init({ name: e, background: t, widgetOpenClasses: s = [], bodyOpenClasses: r = [], attributes: i = {} }) {
    ((this._name = e),
      (this._isOpen = !1),
      (this._selectors = { background: t, open: this.getAttribute("open"), close: this.getAttribute("close") }),
      (this._nodes = { background: document.querySelector(this._selectors.background) }),
      (this._events = {
        open: ["focusable-widget:open", e + ":open", this.id + ":open"],
        close: ["focusable-widget:close", e + ":close", this.id + ":close"],
      }),
      (this._config = {
        open: document.querySelectorAll(this._selectors.open),
        close: document.querySelectorAll(this._selectors.close),
        attributes: { "data-focusable-widget": "true", "aria-hidden": "true", tabindex: 0, ...i },
        widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(s),
        bodyOpenClasses: ["js-focusable-widget-open", `js-${e}-open`, this.getAttribute("body-open-class")].concat(r),
      }),
      this._validateConfig(),
      this._addAccessibilityAttributes(),
      this._setupListeners());
  }
  _validateConfig() {
    if (
      ((this._config.open && this._config.open.length) ||
        console.warn(
          `WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`,
        ),
        !this._config.close || !this._config.close.length)
    )
      throw new Error(
        `${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`,
      );
  }
  _setupListeners() {
    (this._config.open.forEach((e) => e.addEventListener("click", this._open.bind(this))),
      this._config.close.forEach((e) => e.addEventListener("click", this._close.bind(this))),
      this.addEventListener("click", (e) => {
        e.stopPropagation();
        if (e.target.closest(this._selectors.close)) this._close(e);
      }));
  }
  _open(e) {
    (e && (e.preventDefault(), e.stopPropagation()), this.open());
  }
  _close = (e) => {
    (e && (e.preventDefault(), e.stopPropagation()), this.close());
  };
  _closeFocusableWidgets() {
    document.querySelectorAll("[data-focusable-widget].open").forEach((e) => e.close());
  }
  _dispatchEvents(e, t) {
    (e.forEach((e) => document.dispatchEvent(new CustomEvent(e))),
      t && t.length && t.forEach((e) => this.dispatchEvent(new CustomEvent(e))));
  }
  _bindEvents() {
    (document.addEventListener("keyup", this._onKeyUp),
      this._nodes.background.addEventListener("click", this._close),
      this._nodes.background.addEventListener("touchmove", this._onTouchMove));
  }
  _unbindEvents() {
    (document.removeEventListener("keyup", this._onKeyUp),
      this._nodes.background.removeEventListener("click", this._close),
      this._nodes.background.removeEventListener("touchmove", this._onTouchMove));
  }
  _toggleClasses() {
    this._isOpen
      ? (this._config.bodyOpenClasses.forEach((e) => {
        e && document.body.classList.remove(e);
      }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.remove(e);
        }))
      : (this._config.bodyOpenClasses.forEach((e) => {
        e && document.body.classList.add(e);
      }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.add(e);
        }));
  }
  _toggleAccessibilityAttributes() {
    this._isOpen
      ? (this.setAttribute("aria-hidden", "true"),
        this.setAttribute("tabindex", "-1"),
        this._config.open.forEach((e) => e.setAttribute("aria-expanded", "false")),
        this._config.close.forEach((e) => e.setAttribute("aria-expanded", "false")))
      : (this.setAttribute("aria-hidden", "false"),
        this.setAttribute("tabindex", "0"),
        this._config.open.forEach((e) => e.setAttribute("aria-expanded", "true")),
        this._config.close.forEach((e) => e.setAttribute("aria-expanded", "true")));
  }
  _addAccessibilityAttributes() {
    var e,
      t = (e) => {
        (e.setAttribute("tabindex", "0"),
          e.setAttribute("aria-expanded", "false"),
          e.setAttribute("aria-controls", this.id));
      };
    for (e in this._config.attributes) this.setAttribute(e, this._config.attributes[e]);
    (this._config.open.forEach(t), this._config.close.forEach(t));
  }
  _onKeyUp = (e) => {
    "ESCAPE" === e.code.toUpperCase() && this.close();
  };
  _onTouchMove = () => !1;
}
class Drawer extends FocusableWidget {
  constructor() {
    super({ name: "drawer", background: ".drawer-background" });
    var e = this.getAttribute("position");
    if (!e) throw new Error("drawer must have position attribute");
    ((this._position = e),
      this._config.bodyOpenClasses.push(`js-drawer-${e}-open`),
      (this._clientConfig.bodyOpenClasses = [`js-drawer-${e}-open`]));
  }
  get position() {
    return this._position;
  }
}
class Modal extends FocusableWidget {
  constructor() {
    super({ name: "modal", background: ".modal-background", bodyOpenClasses: "js-modal-open" });
  }
}
class Accordion extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        accordion: "[js-accordion]",
        accordionItem: "[js-accordion-item]",
        accordionHeader: "[js-accordion-header]",
        accordionContent: "[js-accordion-content]",
      }));
  }
  connectedCallback() {
    ((this.buttons = this.querySelectorAll(this._selectors.accordionHeader)),
      this.buttons.forEach((e) => {
        e.addEventListener("click", this._toggleContent);
      }),
      (this.content = this.querySelectorAll(this._selectors.accordionContent)));
  }
  _toggleContent = (e) => {
    e.stopImmediatePropagation();
    var e = e.currentTarget,
      t = this.querySelector("#" + e.getAttribute("aria-controls")),
      s = theme.utils.getSiblings(e.parentElement, this._selectors.accordionItem);
    "false" == e.getAttribute("aria-expanded")
      ? (e.setAttribute("aria-expanded", !0),
        theme.utils.prepareTransition(t),
        this._expandSection(t),
        (this.dataset.manualCollapse && "false" != this.dataset.manualCollapse) ||
        s.forEach((e) => {
          var t = e.querySelector(this._selectors.accordionHeader),
            e = e.querySelector("#" + t.getAttribute("aria-controls"));
          "true" == t.getAttribute("aria-expanded") &&
            (t.setAttribute("aria-expanded", !1), this._collapseSection(e));
        }))
      : (e.setAttribute("aria-expanded", !1), this._collapseSection(t));
  };
  _collapseSection(e) {
    e.setAttribute("aria-hidden", !0);
  }
  _expandSection(e) {
    e.setAttribute("aria-hidden", !1);
  }
}
class Tabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((this._elements = {
      tabs: this.querySelectorAll("[js-tab]"),
      tabList: this.querySelectorAll("[js-tab-list]"),
      tabPanel: this.querySelectorAll("[js-tab-panel]"),
    }),
      this._tabEventListener(),
      this._tabListListener());
  }
  _tabEventListener = () => {
    var e = this._elements.tabs;
    e.forEach((e) => e.addEventListener("click", this._showTabPanel));
  };
  _showTabPanel = (e) => {
    var t = this._elements.tabs;
    for (let e = 0; e < t.length; e++) t[e].setAttribute("aria-selected", "false");
    e.target.setAttribute("aria-selected", "true");
    var e = e.currentTarget.getAttribute("aria-controls"),
      s = this.querySelectorAll("[role=tabpanel]");
    for (let e = 0; e < s.length; e++) s[e].setAttribute("aria-hidden", "true");
    document.getElementById(e).setAttribute("aria-hidden", "false");
  };
  _tabListListener = () => {
    var e = this._elements.tabList;
    e.forEach((e) => e.addEventListener("keydown", this._tabListKeydown));
  };
  _tabListKeydown = (e) => {
    (37 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      38 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      39 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault()),
      40 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault()));
  };
}
class Carousel extends HTMLElement {
  constructor() {
    (super(),
      (this.selectors = {
        carousel: "[js-carousel]",
        hotspotScrollbar: "[js-scrollbar-product-hotspot]",
        reviewsScrollbar: "[js-scrollbar-product-reviews]",
      }),
      (this.options = {
        loop: !0,
        slidesPerView: "auto",
        grabCursor: !0,
        centeredSlides: !1,
        navigation: !1,
        pagination: !1,
      }));
  }
  connectedCallback() {
    var e;
    ((e =
      "hotspot" === this.dataset.carouselType
        ? {
          scrollbar: !0,
          loop: !1,
          slidesPerView: 1,
          spaceBetween: 0,
          scrollbar: { el: this.querySelector(this.selectors.hotspotScrollbar), hide: !1, draggable: !0 },
        }
        : "reviews" === this.dataset.carouselType
          ? {
            scrollbar: !0,
            loop: !1,
            slidesPerView: 1,
            spaceBetween: 0,
            scrollbar: { el: this.querySelector(this.selectors.reviewsScrollbar), hide: !1, draggable: !0 },
          }
          : this.dataset.options
            ? JSON.parse(this.dataset.options)
            : {}),
      this._applyPaginationFormatters(e),
      (this.options = Object.assign(this.options, e)),
      void 0 !== this.dataset.numberOfSlides &&
      ((this.options.pagination.type = "custom"),
        (this.options.pagination.renderCustom = function (swiper) {
          var total = swiper && swiper.slides ? swiper.slides.length : 0,
            current = total ? swiper.realIndex + 1 : 0;
          return ("0" + current).slice(-2) + " / " + ("0" + total).slice(-2);
        })),
      void 0 !== this.dataset.connectedCarousel &&
      ((e = document.querySelector("#" + this.dataset.connectedCarousel)),
        (this.options = Object.assign(this.options, { thumbs: { swiper: e.swiper } }))),
      this._initCarousel());
  }
  _applyPaginationFormatters(e) {
    e.pagination &&
      "fraction" === e.pagination.type &&
      ((e.pagination.formatFractionCurrent = this._formatNumberWithLeadingZero),
        (e.pagination.formatFractionTotal = this._formatNumberWithLeadingZero));
  }
  _formatNumberWithLeadingZero(e) {
    return e < 10 ? "0" + e : e.toString();
  }
  _initCarousel() {
    let e = "#" + this.querySelector(this.selectors.carousel).id;
    if (
      (void 0 !== this.dataset.init
        ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
          match: function () {
            this.carousel = new Swiper(e, this.options);
          }.bind(this),
          unmatch: function () {
            this.carousel.el.classList.contains("swiper-initialized") && this.carousel.destroy(!0, !0);
          }.bind(this),
        })
        : (this.carousel = new Swiper(e, this.options)),
        null != this.dataset.connectedCarousel && null != this.carousel)
    ) {
      let e = document.querySelector("#" + this.dataset.connectedCarousel),
        t = this.carousel;
      (t.on("slideChangeTransitionStart", function () {
        (e.swiper.slideTo(t.realIndex, 300, !1),
          e.swiper.slides.forEach((e) => {
            e.classList.remove("swiper-slide-active", "swiper-slide-thumb-active");
          }),
          e.swiper.slides.length &&
          e.swiper.slides[t.realIndex].classList.add("swiper-slide-active", "swiper-slide-thumb-active"));
      }),
        enquire.register(theme.config.mediaQueries.desktop, {
          match: function () {
            e.swiper.on("transitionEnd", function () {
              e.swiper.slides[t.realIndex].classList.contains("swiper-slide-active") ||
                t.slideTo(e.swiper.activeIndex, 300, !1);
            });
          }.bind(this),
          unmatch: function () { }.bind(this),
        }));
    }
  }
}
class SiteHeader extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        headerTop: "[js-header-top]",
        megaMenuTrigger: "[js-mega-menu-trigger]",
      }));
  }
  connectedCallback() {
    ((this.header = this.closest(".shopify-section-header")),
      (this.headerTop = this.querySelector(this._selectors.headerTop)),
      (this.megaMenuTriggers = this.querySelectorAll(this._selectors.megaMenuTrigger)),
      this._setVariables(),
      this._watchWindowResize(),
      this._setListeners());
  }
  _setListeners() {
    ("fixed" == this.dataset.header && document.addEventListener("scroll", this._headerBackground),
      this.headerTop.addEventListener("mouseenter", this._removeTransition),
      this.headerTop.addEventListener("mouseleave", this._addTransition),
      this.megaMenuTriggers.forEach((e) => {
        e.addEventListener("mouseleave", (e) => {
          e.currentTarget.blur();
        });
      }));
  }
  _watchWindowResize = (e) => {
    window.addEventListener("resize", this._setVariables);
  };
  _setVariables = (e) => {
    let i = 0;
    document.querySelectorAll(".announcement-bar, .header-group-announcement").forEach((e) => {
      i += e.offsetHeight;
    });
    let t = 0;
    document.querySelectorAll(".shop-announcement-bar-section .header-group-announcement").forEach((e) => {
      t += e.offsetHeight;
    });
    var n = this.parentElement?.clientHeight ?? 0;
    (document.documentElement.style.setProperty("--announcement-bar-height", i + "px"),
      document.documentElement.style.setProperty("--announcement-bar-external-height", t + "px"),
      document.documentElement.style.setProperty("--header-height", n + t + "px"));
  };
  _headerBackground = (e) => {
    0 < (window.pageYOffset || document.documentElement.scrollTop)
      ? this.headerTop.classList.add("active")
      : this.headerTop.classList.remove("active");
  };
  _removeTransition = (e) => {
    setTimeout(() => {
      this.headerTop.classList.add("no-transition");
    }, 300);
  };
  _addTransition = (e) => {
    this.headerTop.classList.remove("no-transition");
  };
}
class MobileNav extends HTMLElement {
  constructor() {
    (super(), (this._selectors = { back: "[js-back-mobile-nav]", accordionTrigger: "[js-accordion-header]" }));
  }
  connectedCallback() {
    ((this.backButtons = this.querySelectorAll(this._selectors.back)), this._setupEventListeners());
  }
  _setupEventListeners() {
    this.backButtons.forEach((e) => {
      e.addEventListener("click", this._onBackClick);
    });
  }
  _onBackClick = (e) => {
    e = e.currentTarget.dataset.controls;
    document.querySelector('.accordion-header[aria-controls="' + e + '"]').click();
  };
}
theme.cartQuantityLimits = {
  getConfig() {
    var settingsElement = document.getElementById("CartQuantityLimitsSettings");
    var defaultMessages = {
      cartTotalMax: 25,
      saleLineMax: 5,
      msgAddTotal: "You've reached the maximum number of items in your cart.",
      msgAddSale: "You've reached the maximum for sale or discounted items in your cart.",
    };
    if (!settingsElement) return defaultMessages;
    try {
      var settings = JSON.parse(settingsElement.textContent || "{}");
      var cartTotalMax = parseInt(settings.cartTotalMax, 10);
      if (isNaN(cartTotalMax) || cartTotalMax < 1) cartTotalMax = parseInt(settings.defaultMax, 10);
      if (isNaN(cartTotalMax) || cartTotalMax < 1) cartTotalMax = 25;
      var saleCartMax = parseInt(settings.saleLineMax, 10);
      if (isNaN(saleCartMax) || saleCartMax < 1) saleCartMax = parseInt(settings.saleOrDiscountMax, 10);
      if (isNaN(saleCartMax) || saleCartMax < 1) saleCartMax = 5;
      return {
        cartTotalMax: Math.max(1, cartTotalMax),
        saleLineMax: Math.max(1, saleCartMax),
        msgAddTotal: settings.msgAddTotal || defaultMessages.msgAddTotal,
        msgAddSale: settings.msgAddSale || defaultMessages.msgAddSale,
      };
    } catch (parseError) {
      return defaultMessages;
    }
  },
  _getVariantSaleMap() {
    var mapElement = document.getElementById("CartVariantSaleMap");
    if (!mapElement) return {};
    try {
      return JSON.parse(mapElement.textContent || "{}");
    } catch (parseError) {
      return {};
    }
  },
  lineIsSaleOrDiscount(lineItem) {
    if (!lineItem) return false;
    var variantSaleMap = this._getVariantSaleMap();
    return variantSaleMap[String(lineItem.variant_id)] === true;
  },
  lineIsGift(lineItem) {
    if (!lineItem || !lineItem.properties) return false;
    return !!(
      lineItem.properties._GWP ||
      lineItem.properties._threshold_free_gift ||
      lineItem.properties._auto_gwp_free_gift
    );
  },
  currentQtyForVariant(cart, variantId) {
    var quantityOnVariant = 0;
    if (!cart || !cart.items) return 0;
    cart.items.forEach(function (lineItem) {
      if (Number(lineItem.variant_id) === Number(variantId)) quantityOnVariant += lineItem.quantity;
    });
    return quantityOnVariant;
  },
  saleQtyInCart(cart) {
    var totalSaleQuantity = 0;
    if (!cart || !cart.items) return 0;
    var limits = theme.cartQuantityLimits;
    cart.items.forEach(function (lineItem) {
      if (limits.lineIsGift(lineItem)) return;
      if (limits.lineIsSaleOrDiscount(lineItem)) totalSaleQuantity += lineItem.quantity;
    });
    return totalSaleQuantity;
  },
  canAddItems(cart, variantId, addQuantity, isOnSale) {
    if (!cart || !cart.items) return { ok: true };
    var config = this.getConfig();
    var quantityToAdd = parseInt(String(addQuantity), 10) || 0;
    if (cart.item_count + quantityToAdd > config.cartTotalMax) return { ok: false, reason: "total" };
    if (!isOnSale) return { ok: true };
    if (this.saleQtyInCart(cart) + quantityToAdd > config.saleLineMax) return { ok: false, reason: "sale" };
    return { ok: true };
  },
  getAddBlockedMessage(reason) {
    var config = this.getConfig();
    return reason === "sale" ? config.msgAddSale : config.msgAddTotal;
  },
  showDrawerCartError(reason) {
    var errorElement = document.getElementById("CartDrawer-CartErrors");
    if (errorElement) {
      errorElement.textContent = this.getAddBlockedMessage(reason);
      errorElement.classList.remove("hidden");
    }
    var cartDrawer = document.getElementById("CartDrawer");
    if (cartDrawer && typeof cartDrawer.open === "function") cartDrawer.open();
  },
  clearDrawerCartError() {
    var errorElement = document.getElementById("CartDrawer-CartErrors");
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.classList.add("hidden");
    }
  },
  getLineQuantityCap(lineIndexOneBased, cartItems, lineItem) {
    var input =
      document.getElementById("Quantity-" + lineIndexOneBased) ||
      document.getElementById("Drawer-quantity-" + lineIndexOneBased);
    if (input) {
      var domMax = parseInt(String(input.getAttribute("max")), 10);
      if (!isNaN(domMax) && domMax > 0) return domMax;
    }
    return this.maxQuantityForLine(cartItems, lineIndexOneBased, lineItem);
  },
  maxQuantityForLine(cartItems, lineIndexOneBased, lineItem) {
    var config = this.getConfig();
    var otherLinesQuantity = 0;
    cartItems.forEach(function (item, index) {
      if (index !== lineIndexOneBased - 1) otherLinesQuantity += item.quantity;
    });
    var globalRoom = config.cartTotalMax - otherLinesQuantity;
    if (globalRoom < 0) globalRoom = 0;
    var cap = globalRoom;
    if (!this.lineIsGift(lineItem) && this.lineIsSaleOrDiscount(lineItem)) {
      var totalSaleQuantity = 0;
      var limits = this;
      cartItems.forEach(function (item) {
        if (limits.lineIsGift(item)) return;
        if (limits.lineIsSaleOrDiscount(item)) totalSaleQuantity += item.quantity;
      });
      var saleQuantityOtherLines = totalSaleQuantity - lineItem.quantity;
      var saleCartRoom = config.saleLineMax - saleQuantityOtherLines;
      if (saleCartRoom < 0) saleCartRoom = 0;
      cap = Math.min(globalRoom, saleCartRoom);
    }
    if (cap < 1) cap = 1;
    return cap;
  },
  _atcRefreshTimer: null,
  scheduleRefreshAtcState() {
    var limits = this;
    clearTimeout(this._atcRefreshTimer);
    this._atcRefreshTimer = setTimeout(function () {
      limits.refreshAddToCartButtonsState();
    }, 250);
  },
  refreshAddToCartButtonsState() {
    fetch("" + routes.cart_url + ".js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll("[js-add-to-cart]").forEach(function (button) {
          if (button.closest && button.closest("s-modal.quick-view-modal")) return;
          var variantId = button.dataset.variantId;
          if (!variantId) return;
          var isPdpPrimaryAddToCart =
            button.matches && (button.matches("[js-main-add-to-cart]") || button.matches("[js-sticky-atc]"));
          var quickAddHost = button.closest && button.closest("quick-add");
          var isOnSale = button.dataset.variantOnSale === "true";
          var limitCheck = theme.cartQuantityLimits.canAddItems(cart, variantId, 1, isOnSale);
          if (button.dataset.variantAvailable === "false") {
            button.disabled = true;
            button.setAttribute("disabled", "");
          } else if (limitCheck.ok) {
            button.disabled = false;
            button.removeAttribute("disabled");
            button.removeAttribute("aria-disabled");
          } else if (isPdpPrimaryAddToCart || quickAddHost) {
            button.disabled = false;
            button.removeAttribute("disabled");
            button.removeAttribute("aria-disabled");
          } else {
            button.disabled = true;
            button.setAttribute("disabled", "");
            button.setAttribute("aria-disabled", "true");
          }
        });
      })
      .catch(function () { });
  },
};
class CartRemoveButton extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener("click", (e) => {
        e.preventDefault();
        e = this.closest("cart-items") || this.closest("cart-drawer-items");
        (e.updateQuantity(this.dataset.index, 0),
          "cartPage" == e.dataset.source &&
          document.querySelector("cart-drawer-items").updateQuantity(this.dataset.index, 0));
      }));
  }
}
class CartItems extends HTMLElement {
  constructor() {
    super();
    var e = theme.utils.debounce((e) => {
      this.onChange(e);
    }, 300);
    this.addEventListener("change", e.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    ((this.cartUpdateUnsubscriber = theme.utils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (e) => {
      ("cartDrawer" == e.source && "cartDrawer" == this.dataset.source) ||
        ("cartPage" != e.source && this.onCartUpdate());
    })),
      "true" == this.dataset.gwp && this.handleGWP());
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(e) {
    var t = e.target;
    if (!t || !t.dataset || null == t.dataset.index || "" === t.dataset.index) return;
    if (!/^\d+$/.test(String(t.dataset.index))) return;
    (this.updateQuantity(t.dataset.index, t.value, document.activeElement.getAttribute("name")),
      "cartPage" == this.dataset.source &&
      document
        .querySelector("cart-drawer-items")
        .updateQuantity(t.dataset.index, t.value, document.activeElement.getAttribute("name")));
  }
  onCartUpdate() {
    fetch(routes.cart_url + "?section_id=cart__main")
      .then((e) => e.text())
      .then((e) => {
        e = new DOMParser().parseFromString(e, "text/html").querySelector("cart-items");
        ((this.innerHTML = e.innerHTML), this.handleGWP());
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "CartPage-CartItems",
        section: document.getElementById("CartPage-CartItems").dataset.id,
        selector: "[js-cart-page-contents]",
      },
    ];
  }
  updateQuantity(c, l, d) {
    (this.enableLoading(c),
      fetch(routes.cart_url + ".js")
        .then((e) => e.json())
        .then((o) => {
          let n = o.items[c - 1];
          var e;
          if (n) {
            var requestedQ = parseInt(String(l), 10);
            !isNaN(requestedQ) &&
              requestedQ > n.quantity &&
              window.revealCartLimitBannersOnShopperIntent &&
              window.revealCartLimitBannersOnShopperIntent();
            var cap = theme.cartQuantityLimits.getLineQuantityCap(c, o.items, n),
              q = parseInt(String(l), 10);
            if (!isNaN(q) && 0 < q && cap < q) {
              l = String(cap);
              var inp = document.getElementById("Quantity-" + c) || document.getElementById("Drawer-quantity-" + c);
              inp && (inp.value = l);
            }
          }
          n &&
            ((e = JSON.stringify({
              line: c,
              quantity: l,
              sections: this.getSectionsToRender().map((e) => e.section),
              sections_url: window.location.pathname,
            })),
              fetch("" + routes.cart_change_url, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: e,
              })
                .then((e) => e.text())
                .then((t) => {
                  let s = JSON.parse(t);
                  var t = document.getElementById("Quantity-" + c) || document.getElementById("Drawer-quantity-" + c),
                    r = document.querySelectorAll("[js-cart-item]");
                  if (s.errors) ((t.value = t.getAttribute("value")), this.updateLiveRegions(c, s.errors));
                  else {
                    if (0 === l) {
                      var i = o.items.filter(
                        (e) =>
                          !(!e.properties || !e.properties._auto_gwp_free_gift) &&
                          e.properties._auto_gwp_free_gift === n.variant_id.toString(),
                      );
                      if (0 < i.length) {
                        let s = {};
                        i.forEach((e, t) => {
                          s[e.key] = 0;
                        });
                        i = JSON.stringify({
                          updates: s,
                          sections: this.getSectionsToRender().map((e) => e.section),
                          sections_url: window.location.pathname,
                        });
                        fetch("" + routes.cart_update_url, {
                          method: "POST",
                          headers: { "Content-Type": "application/json", Accept: "application/json" },
                          body: i,
                        })
                          .then((e) => e.text())
                          .then((e) => {
                            let t = JSON.parse(e);
                            this.getSectionsToRender().forEach((e) => {
                              if ("cart-count" === e.section) {
                                var drawer = document.querySelector("cart-drawer");
                                return void (
                                  drawer && t.sections[e.section] && drawer.updateCartCount(t.sections[e.section])
                                );
                              }
                              (
                                document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)
                              ).innerHTML = this.getSectionInnerHTML(t.sections[e.section], e.selector);
                            });
                          })
                          .catch((e) => {
                            console.error("Error removing free gifts:", e);
                          });
                      }
                    }
                    var i = document.querySelector("cart-drawer"),
                      a =
                        (this.getSectionsToRender().forEach((e) => {
                          if ("cart-count" === e.section) {
                            var drawer = document.querySelector("cart-drawer");
                            return void (
                              drawer && s.sections[e.section] && drawer.updateCartCount(s.sections[e.section])
                            );
                          }
                          (
                            document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)
                          ).innerHTML = this.getSectionInnerHTML(s.sections[e.section], e.selector);
                        }),
                          s.items[c - 1] ? s.items[c - 1].quantity : void 0);
                    let e = "";
                    (r.length === s.items.length &&
                      a !== parseInt(t.value) &&
                      (e =
                        void 0 === a
                          ? "There was an error while updating your cart. Please try again."
                          : `You can only add ${a} of this item to your cart.`),
                      this.updateLiveRegions(c, e));
                    r = document.getElementById("CartItem-" + c) || document.getElementById("CartDrawer-Item-" + c);
                    (r && r.querySelector(`[name="${d}"]`)
                      ? i
                        ? theme.utils.a11y.trapFocus(i, r.querySelector(`[name="${d}"]`))
                        : r.querySelector(`[name="${d}"]`).focus()
                      : (0 === s.item_count && i) ||
                      (document.querySelector("[js-cart-item]") &&
                        i &&
                        theme.utils.a11y.trapFocus(i, document.querySelector("[js-cart-item-image]"))),
                      theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                        source: this.dataset.source,
                      }));
                  }
                })
                .catch((e) => {
                  (console.log(e),
                    this.querySelectorAll(".loading-overlay").forEach((e) => e.classList.add("hidden")),
                    ((
                      document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")
                    ).textContent = "There was an error while updating your cart. Please try again."));
                })
                .finally(() => {
                  (this.disableLoading(c),
                    document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate());
                }));
        })
        .catch((e) => {
          console.error("Error fetching initial cart data:", e);
        }));
  }
  updateLiveRegions(e, t) {
    e = document.getElementById("Line-item-error-" + e) || document.getElementById("CartDrawer-LineItemError-" + e);
    e && (e.innerHTML = t);
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }
  enableLoading(e) {
    (document.getElementById("CartPage-CartItems") || document.getElementById("CartDrawer-CartItems")).classList.add(
      "cart__items--disabled",
    );
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    ([...t, ...e].forEach((e) => e.setAttribute("loading", "")), document.activeElement.blur());
  }
  disableLoading(e) {
    (document.getElementById("CartPage-CartItems") || document.getElementById("CartDrawer-CartItems")).classList.remove(
      "cart__items--disabled",
    );
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach((e) => e.removeAttribute("loading"));
  }
  checkoutBtnState(e = !0) {
    let t;
    (t =
      "cartPage" == this.dataset.source
        ? this.querySelector("#CartPage-Checkout")
        : document.querySelector("#CartDrawer-Checkout")) &&
      (e ? t.setAttribute("disabled", "") : t.removeAttribute("disabled"));
  }
  hideGwpError = () => {
    var e = this.gwpContainer.querySelector('[data-show="true"][js-gwp-error]');
    e && (e.dataset.show = "false");
  };
  showGwpError = (e, t) => {
    e = this.gwpContainer.querySelector(`[data-gwp="${e}"][js-gwp-block] [js-gwp-error]`);
    ((e.textContent = t), (e.dataset.show = "true"));
  };
  gwpContainerState = (e = !0) => {
    var t = this.gwpContainer.querySelector("loading-spinner");
    e ? t.setAttribute("loading", "") : t.removeAttribute("loading");
  };
  removeGWP(r) {
    (async () => {
      var e = (await this.getCartContents()).items;
      if (r) {
        console.log(r);
        var s = e.filter((e) => e.properties?._GWP == r);
        let t = {};
        (console.log(s),
          s.forEach((e) => {
            t[e.key] = 0;
          }),
          document.querySelector("cart-drawer").setActiveElement(document.activeElement));
        s = {
          updates: t,
          sections: document
            .querySelector("cart-drawer")
            .getSectionsToRender()
            .map((e) => e.id),
        };
        this.updateCart(s, !0);
      } else {
        let t = [];
        this.gwpContainer &&
          this.gwpBlocks.forEach((e) => {
            t.push(e.dataset.gwp);
          });
        s = e.filter((e) => e.properties?._GWP && !t.includes(e.properties._GWP));
        if (0 < s.length) {
          let t = {};
          (s.forEach((e) => {
            t[e.key] = 0;
          }),
            document.querySelector("cart-drawer").setActiveElement(document.activeElement));
          e = {
            updates: t,
            sections: document
              .querySelector("cart-drawer")
              .getSectionsToRender()
              .map((e) => e.id),
          };
          this.updateCart(e, !0);
        }
      }
    })();
  }
  handleGWP() {
    var e;
    ((this.gwpContainer = this.querySelector("[js-gwp-container]")),
      (this.gwpBlocks = this.gwpContainer?.querySelectorAll("[js-gwp-block]")),
      this.removeGWP(),
      this.gwpContainer &&
      ((e = this.gwpContainer.querySelector('[data-added-to-cart="true"][data-unlocked="false"][js-gwp-block]'))
        ? this.removeGWP(e.dataset.gwp)
        : (this.gwpContainer.querySelectorAll("[js-gwp-atc]").forEach((e) => {
          e.addEventListener("click", (e) => {
            (e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.hideGwpError());
            var e = e.currentTarget.closest("[js-gwp-block]"),
              t = this.gwpContainer.querySelector('[data-added-to-cart="true"][js-gwp-block]');
            t && "true" !== t.dataset.multiple
              ? (localStorage.setItem("gwpToAdd", e.dataset.gwp), this.removeGWP(t.dataset.gwp))
              : (document.querySelector("cart-drawer").setActiveElement(document.activeElement),
                (t = {
                  items: [{ id: e.dataset.variantId, quantity: 1, properties: { _GWP: e.dataset.gwp } }],
                  sections: document
                    .querySelector("cart-drawer")
                    .getSectionsToRender()
                    .map((e) => e.id),
                }),
                this.addToCart(t, e.dataset.gwp));
          });
        }),
          (e = localStorage.getItem("gwpToAdd")) &&
          (localStorage.removeItem("gwpToAdd"),
            this.gwpContainer.querySelector(`[data-gwp="${e}"][js-gwp-block] [js-gwp-atc]`)?.click()),
          this.gwpContainer.querySelectorAll("[js-gwp-remove]").forEach((e) => {
            e.addEventListener("click", (e) => {
              (e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.hideGwpError());
              e = e.currentTarget.closest("[js-gwp-block]");
              this.removeGWP(e.dataset.gwp);
            });
          }))));
  }
  addToCart(e, t) {
    return (
      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent(),
      this.checkoutBtnState(!0),
      this.gwpContainerState(!0),
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((e) => e.json())
        .then(
          (e) => (
            "Cart Error" == e.message
              ? this.showGwpError(t, e.description)
              : document.querySelector("cart-drawer").renderContents(e),
            e
          ),
        )
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          (this.checkoutBtnState(!1),
            this.gwpContainerState(!1),
            document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate());
        })
    );
  }
  getCartContents() {
    return fetch("" + routes.cart_url, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
    })
      .then((e) => e.json())
      .then((e) => e)
      .catch((e) => {
        console.error("Error:", e);
      });
  }
  updateCart(e, t = !1) {
    return (
      this.checkoutBtnState(!0),
      t && this.gwpContainerState(!0),
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((e) => e.json())
        .then((e) => (document.querySelector("cart-drawer").renderContents(e), e))
        .catch((e) => {
          (console.log(e),
            this.querySelectorAll(".loading-overlay").forEach((e) => e.classList.add("hidden")),
            ((
              document.getElementById("CartPage-CartErrors") || document.getElementById("CartDrawer-CartErrors")
            ).textContent = "There was an error while updating your cart. Please try again."));
        })
        .finally(() => {
          (this.checkoutBtnState(!1),
            t && this.gwpContainerState(!1),
            document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate());
        })
    );
  }
}
class CartNote extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener(
        "change",
        debounce((e) => {
          e = JSON.stringify({ note: e.target.value });
          fetch("" + routes.cart_update_url, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: e,
          });
        }, ON_CHANGE_DEBOUNCE_TIMER),
      ));
  }
}
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
  renderContents(t) {
    this.productId = t.id;
    (["[js-cart-drawer-header]", "[js-cart-drawer-empty]", "[js-cart-drawer-body]", "[js-cart-drawer-footer]"].forEach(
      (e) => {
        document.querySelector(e).innerHTML = this.getSectionInnerHTML(t.sections.cart, e);
      },
    ),
      t.sections && t.sections["cart-count"] && this.updateCartCount(t.sections["cart-count"]));
  }
  updateCartCount(sectionHtml) {
    var el = document.querySelector("#cart-count");
    if (!el || !sectionHtml) return;
    var parsed = new DOMParser().parseFromString(sectionHtml, "text/html"),
      section = parsed.querySelector(".shopify-section"),
      countText = (section ? section.textContent : parsed.body.textContent || "").trim(),
      count = parseInt(countText, 10);
    ((el.textContent = isNaN(count) ? countText : String(count)),
      el.classList.toggle("hidden", !(count > 0)),
      el.classList.toggle("flex", count > 0));
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }
  getSectionsToRender() {
    return [{ id: "cart", selector: "#cart" }, { id: "cart-count" }];
  }
  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "cart", section: "cart", selector: "[js-cart-drawer-contents]" },
      { id: "cart-count", section: "cart-count", selector: ".shopify-section" },
    ];
  }
  onCartUpdate() {
    fetch("" + routes.cart_url + "?section_id=cart")
      .then((e) => e.text())
      .then((e) => {
        e = new DOMParser().parseFromString(e, "text/html").querySelector("cart-drawer-items");
        e && ((this.innerHTML = e.innerHTML), this.handleGWP());
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
function thresholdFreeGiftSectionIds() {
  var e = document.querySelector("cart-drawer");
  return e ? e.getSectionsToRender().map(function (e) {
    return e.id;
  }) : [];
}
function fetchCartJsFresh() {
  return fetch("" + routes.cart_url + ".js?v=" + Date.now(), { cache: "no-store", credentials: "same-origin" }).then(
    function (e) {
      return e.json();
    },
  );
}
var thresholdGiftSyncInFlight = !1,
  thresholdGiftDebounceTimer = void 0;
function getThresholdGiftPropertyName(giftEl) {
  return (giftEl && giftEl.getAttribute("data-gift-property")) || "_threshold_free_gift";
}
function getThresholdGiftTier(giftEl) {
  return (giftEl && giftEl.getAttribute("data-gift-tier")) || "";
}
function getThresholdGiftChangeModeKey(giftEl) {
  var instanceId = (giftEl && giftEl.getAttribute("data-instance-id")) || "threshold";
  return "thresholdGiftChangeMode:" + instanceId;
}
function buildThresholdGiftPropertyValue(tier, handle) {
  return tier ? String(tier) + "|" + handle : handle;
}
function getThresholdGiftLinesForEl(cart, giftEl) {
  var prop = getThresholdGiftPropertyName(giftEl),
    tier = getThresholdGiftTier(giftEl);
  return cart.items.filter(function (item) {
    if (!item.properties || item.properties[prop] == null || item.properties[prop] === "") return !1;
    var value = String(item.properties[prop]);
    if (tier) return value.indexOf(String(tier) + "|") === 0;
    return value.indexOf("|") === -1;
  });
}
function setThresholdGiftAutoAdding(active, giftEl) {
  giftEl = giftEl || document.querySelector("threshold-free-gift");
  if (!giftEl) return;
  giftEl.classList.toggle("threshold-free-gift--auto-adding", active);
  var statusEl = giftEl.querySelector("[js-threshold-gift-status]");
  var defaultHandle = giftEl.getAttribute("data-default-gift-handle");
  giftEl.querySelectorAll("[js-carousel-slide]").forEach(function (slide) {
    var isDefault = defaultHandle && slide.getAttribute("data-product-handle") === defaultHandle;
    slide.classList.toggle("threshold-free-gift__slide--pending", active && isDefault);
  });
  if (!statusEl) return;
  if (active) {
    if (!statusEl.dataset.defaultStatus) statusEl.dataset.defaultStatus = statusEl.textContent.trim();
    statusEl.textContent = "Adding your free gift…";
    statusEl.classList.remove("text-green");
    statusEl.classList.add("text-red");
  } else if (statusEl.dataset.defaultStatus) {
    statusEl.textContent = statusEl.dataset.defaultStatus;
  }
}
function notifyThresholdGiftCartChildrenUpdated() {
  document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate();
  document.querySelector("cart-drawer-items") && document.querySelector("cart-drawer-items").onCartUpdate();
}
async function manageThresholdFreeGiftCart() {
  if (thresholdGiftSyncInFlight) return;
  var giftEls = Array.prototype.slice.call(
    document.querySelectorAll("threshold-free-gift[data-enabled='true']"),
  );
  if (!giftEls.length) return;
  var sectionIds = thresholdFreeGiftSectionIds(),
    drawer = document.querySelector("cart-drawer");
  if (!sectionIds.length || !drawer) return;
  thresholdGiftSyncInFlight = !0;
  var didUpdate = !1;
  try {
    var cart = await fetchCartJsFresh(),
      updates = {},
      autoAdds = [];
    giftEls.forEach(function (giftEl) {
      var changeMode = !1;
      try {
        changeMode = !!sessionStorage.getItem(getThresholdGiftChangeModeKey(giftEl));
      } catch (storageError) { }
      var unlocked = "true" === String(giftEl.getAttribute("data-unlocked") || "").toLowerCase(),
        defaultHandle = giftEl.getAttribute("data-default-gift-handle"),
        defaultVariantId = parseInt(giftEl.getAttribute("data-default-variant-id") || "0", 10),
        giftLines = getThresholdGiftLinesForEl(cart, giftEl),
        prop = getThresholdGiftPropertyName(giftEl),
        tier = getThresholdGiftTier(giftEl);
      if (!unlocked && giftLines.length) {
        giftLines.forEach(function (item) {
          updates[item.key] = 0;
        });
        try {
          sessionStorage.removeItem(getThresholdGiftChangeModeKey(giftEl));
        } catch (storageError) { }
      } else if (unlocked && 1 < giftLines.length) {
        giftLines.slice(1).forEach(function (item) {
          updates[item.key] = 0;
        });
      }
      if (unlocked && 1 === giftLines.length && 1 < giftLines[0].quantity) {
        updates[giftLines[0].key] = 1;
      }
      if (unlocked && !changeMode && defaultHandle && defaultVariantId && !giftLines.length) {
        autoAdds.push({
          giftEl: giftEl,
          defaultHandle: defaultHandle,
          defaultVariantId: defaultVariantId,
          prop: prop,
          tier: tier,
        });
      }
    });
    if (Object.keys(updates).length) {
      cart = await fetch("" + routes.cart_update_url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates, sections: sectionIds }),
      }).then(function (response) {
        return response.json();
      });
      drawer.renderContents(cart);
      didUpdate = !0;
      giftEls = Array.prototype.slice.call(
        document.querySelectorAll("threshold-free-gift[data-enabled='true']"),
      );
      cart = cart.items ? cart : await fetchCartJsFresh();
      autoAdds = [];
      giftEls.forEach(function (giftEl) {
        var changeMode = !1;
        try {
          changeMode = !!sessionStorage.getItem(getThresholdGiftChangeModeKey(giftEl));
        } catch (storageError) { }
        var unlocked = "true" === String(giftEl.getAttribute("data-unlocked") || "").toLowerCase(),
          defaultHandle = giftEl.getAttribute("data-default-gift-handle"),
          defaultVariantId = parseInt(giftEl.getAttribute("data-default-variant-id") || "0", 10),
          giftLines = getThresholdGiftLinesForEl(cart, giftEl);
        if (unlocked && !changeMode && defaultHandle && defaultVariantId && !giftLines.length) {
          autoAdds.push({
            giftEl: giftEl,
            defaultHandle: defaultHandle,
            defaultVariantId: defaultVariantId,
            prop: getThresholdGiftPropertyName(giftEl),
            tier: getThresholdGiftTier(giftEl),
          });
        }
      });
    }
    if (autoAdds.length) {
      var checkout = document.querySelector("#CartDrawer-Checkout") || document.querySelector("#CartPage-Checkout");
      checkout && checkout.setAttribute("disabled", "");
      try {
        for (var i = 0; i < autoAdds.length; i++) {
          var add = autoAdds[i];
          setThresholdGiftAutoAdding(!0, add.giftEl);
          var props = {};
          props[add.prop] = buildThresholdGiftPropertyValue(add.tier, add.defaultHandle);
          cart = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: add.defaultVariantId, quantity: 1, properties: props }],
              sections: sectionIds,
              sections_url: window.location.pathname,
            }),
          }).then(function (response) {
            return response.json();
          });
          if ("Cart Error" !== cart.message) {
            drawer.renderContents(cart);
            didUpdate = !0;
          }
          setThresholdGiftAutoAdding(!1, add.giftEl);
        }
      } finally {
        checkout && checkout.removeAttribute("disabled");
        giftEls.forEach(function (giftEl) {
          setThresholdGiftAutoAdding(!1, giftEl);
        });
      }
    } else {
      giftEls.forEach(function (giftEl) {
        setThresholdGiftAutoAdding(!1, giftEl);
      });
    }
  } catch (error) {
    console.error(error);
    giftEls.forEach(function (giftEl) {
      setThresholdGiftAutoAdding(!1, giftEl);
    });
  } finally {
    ((thresholdGiftSyncInFlight = !1), didUpdate && notifyThresholdGiftCartChildrenUpdated());
  }
}
function scheduleSyncThresholdFreeGift(immediate) {
  clearTimeout(thresholdGiftDebounceTimer);
  if (immediate)
    return void manageThresholdFreeGiftCart().catch(function (error) {
      console.error(error);
    });
  thresholdGiftDebounceTimer = setTimeout(function () {
    manageThresholdFreeGiftCart().catch(function (error) {
      console.error(error);
    });
  }, 50);
}
class ThresholdFreeGift extends HTMLElement {
  connectedCallback() {
    ((this._onChange = this._onChange.bind(this)),
      (this._onChangeGiftClick = this._onChangeGiftClick.bind(this)),
      (this._onSelectClick = this._onSelectClick.bind(this)),
      this.addEventListener("change", this._onChange, !1),
      this.addEventListener("click", this._onSelectClick, !1),
      this.addEventListener("click", this._onChangeGiftClick, !1));
    try {
      if (sessionStorage.getItem(getThresholdGiftChangeModeKey(this)) && !this.dataset.acceptedVariantId) {
        this._clearPendingAutoDefaultUi();
        this._goToAcceptedSlide();
        return;
      }
      if (sessionStorage.getItem(getThresholdGiftChangeModeKey(this))) {
        sessionStorage.removeItem(getThresholdGiftChangeModeKey(this));
      }
    } catch (storageError) { }
    (this._goToAcceptedSlide(), this._bootstrapAutoAddDefaultGift());
  }
  _clearPendingAutoDefaultUi() {
    this.classList.remove("threshold-free-gift--auto-adding", "threshold-free-gift--accepted");
    this.querySelectorAll(".threshold-free-gift__slide--pending").forEach(function (slide) {
      slide.classList.remove("threshold-free-gift__slide--pending");
    });
    this.querySelectorAll(".threshold-free-gift__slide--dimmed").forEach(function (slide) {
      slide.classList.remove("threshold-free-gift__slide--dimmed");
    });
    this.querySelectorAll(".threshold-free-gift__card--selected").forEach(function (card) {
      card.classList.remove("threshold-free-gift__card--selected", "border-red");
    });
    this.querySelectorAll(".threshold-free-gift__badge").forEach(function (badge) {
      badge.remove();
    });
    this.querySelectorAll(".threshold-free-gift__change--pending").forEach(function (changeEl) {
      changeEl.remove();
    });
    var statusEl = this.querySelector("[js-threshold-gift-status]");
    if (statusEl) {
      var giftCount = parseInt(this.dataset.validGiftCount || "0", 10);
      statusEl.textContent = 1 < giftCount ? "Unlocked — pick one" : "Unlocked";
      statusEl.classList.remove("text-red");
      statusEl.classList.add("text-green");
    }
  }
  _bootstrapAutoAddDefaultGift() {
    if ("true" !== String(this.dataset.unlocked).toLowerCase()) return;
    if (this.dataset.acceptedVariantId) return;
    if (!this.dataset.defaultVariantId) return;
    try {
      if (sessionStorage.getItem(getThresholdGiftChangeModeKey(this))) return;
    } catch (storageError) { }
    setThresholdGiftAutoAdding(!0, this);
    scheduleSyncThresholdFreeGift(!0);
  }
  disconnectedCallback() {
    (this.removeEventListener("change", this._onChange, !1),
      this.removeEventListener("click", this._onSelectClick, !1),
      this.removeEventListener("click", this._onChangeGiftClick, !1));
  }
  _getGiftSelectControl(target) {
    if (!target) return null;
    if (target.matches && target.matches("[js-threshold-gift-select]")) return target;
    return target.closest("[js-threshold-gift-select]");
  }
  _getGiftChangeControl(target) {
    if (!target) return null;
    if (target.matches && target.matches("[js-threshold-gift-change]")) return target;
    return target.closest("[js-threshold-gift-change]");
  }
  _setGiftActionLoading(target, loading, action) {
    var control =
      "change" === action
        ? this._getGiftChangeControl(target)
        : this._getGiftSelectControl(target);
    if (!control) return;
    control.setAttribute("data-loading", loading ? "true" : "false");
    var spinner = control.querySelector("loading-spinner");
    if (spinner) loading ? spinner.setAttribute("loading", "") : spinner.removeAttribute("loading");
    loading ? control.setAttribute("disabled", "") : control.removeAttribute("disabled");
  }
  _canInteractWithSwatches() {
    return "true" === String(this.dataset.unlocked).toLowerCase() && !this.dataset.acceptedVariantId;
  }
  _syncSwatchActiveState(slide, target) {
    if (!slide || !target) return;
    slide.querySelectorAll(".product__swatch-group .product__swatch").forEach(function (labelEl) {
      labelEl.classList.remove("active");
    });
    var activeLabel = slide.querySelector('label[for="' + target.id + '"]');
    if (activeLabel && activeLabel.classList.contains("product__swatch")) activeLabel.classList.add("active");
  }
  _goToAcceptedSlide() {
    var idx = parseInt(this.dataset.acceptedIndex || "", 10);
    if (isNaN(idx) || idx < 0) return;
    var carouselEl = this.querySelector("s-carousel");
    if (!carouselEl) return;
    var attempts = 0;
    var trySlide = function () {
      if (carouselEl.carousel) {
        carouselEl.carousel.slideTo(idx, 0, !1);
      } else if (attempts++ < 60) {
        requestAnimationFrame(trySlide);
      }
    };
    requestAnimationFrame(trySlide);
  }
  _onSelectClick(event) {
    var button = event.target.closest("[js-threshold-gift-select]");
    if (!button || button.hasAttribute("disabled")) return;
    if (this.dataset.acceptedVariantId) return;
    if ("true" !== String(this.dataset.unlocked).toLowerCase()) return;
    event.preventDefault();
    this._acceptGift(button);
  }
  _onChange(event) {
    var target = event.target;
    if (!this._canInteractWithSwatches()) return;
    if (!target || "radio" !== target.type || !target.checked) return;
    if (!target.matches || !target.matches("[js-product-option-selector]")) return;
    if (target.disabled) return;
    var slide = target.closest("[js-carousel-slide]");
    if (!slide) return;
    var productOptions = slide.querySelector("product-options");
    if (!productOptions || !productOptions.contains(target)) return;
    var variantId = parseInt(target.getAttribute("data-variant-id") || "0", 10);
    if (!variantId) return;
    var selectButton = slide.querySelector("[js-threshold-gift-select]");
    selectButton && selectButton.setAttribute("data-variant-id", variantId);
    this._syncSwatchActiveState(slide, target);
    var swatchLabel = slide.querySelector('label[for="' + target.id + '"]'),
      colorName = swatchLabel && (swatchLabel.getAttribute("title") || swatchLabel.getAttribute("aria-label"));
    colorName &&
      slide.querySelectorAll("[js-color-label]").forEach(function (labelEl) {
        labelEl.textContent = colorName;
      });
  }
  _acceptGift(selectButton) {
    var self = this;
    self._setGiftActionLoading(selectButton, !0, "select");
    return (async function () {
      var sectionIds = thresholdFreeGiftSectionIds(),
        drawer = document.querySelector("cart-drawer");
      if (!sectionIds.length || !drawer) return;
      var variantId = parseInt(selectButton.getAttribute("data-variant-id") || "0", 10),
        handle = selectButton.getAttribute("data-product-handle");
      if (!variantId || !handle) {
        self._setGiftActionLoading(selectButton, !1, "select");
        return;
      }
      var checkout = document.querySelector("#CartDrawer-Checkout") || document.querySelector("#CartPage-Checkout"),
        props = {},
        prop = getThresholdGiftPropertyName(self),
        tier = getThresholdGiftTier(self);
      props[prop] = buildThresholdGiftPropertyValue(tier, handle);
      try {
        var cart;
        (checkout && checkout.setAttribute("disabled", ""),
          (cart = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties: props }],
              sections: sectionIds,
            }),
          }).then(function (response) {
            return response.json();
          })));
        if ("Cart Error" !== cart.message) {
          try {
            sessionStorage.removeItem(getThresholdGiftChangeModeKey(self));
          } catch (storageError) { }
          drawer.renderContents(cart);
        }
        (document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate(),
          document.querySelector("cart-drawer-items") && document.querySelector("cart-drawer-items").onCartUpdate());
      } catch (error) {
        console.error(error);
      } finally {
        (checkout && checkout.removeAttribute("disabled"), self._setGiftActionLoading(selectButton, !1, "select"));
      }
    })();
  }
  _onChangeGiftClick(event) {
    var button = event.target.closest("[js-threshold-gift-change]");
    if (!button || button.hasAttribute("disabled")) return;
    event.preventDefault();
    this._onChangeGift({ preventDefault: function () { }, currentTarget: button });
  }
  _onChangeGift(event) {
    var self = this;
    return (async function () {
      var lineKey = self.dataset.acceptedLineKey;
      if (!lineKey) return;
      var sectionIds = thresholdFreeGiftSectionIds(),
        drawer = document.querySelector("cart-drawer");
      if (!sectionIds.length || !drawer) return;
      var checkout = document.querySelector("#CartDrawer-Checkout") || document.querySelector("#CartPage-Checkout"),
        updates = {},
        changeControl = event.currentTarget;
      ((updates[lineKey] = 0), self._setGiftActionLoading(changeControl, !0, "change"));
      try {
        sessionStorage.setItem(getThresholdGiftChangeModeKey(self), "1");
      } catch (storageError) { }
      try {
        var cart;
        (checkout && checkout.setAttribute("disabled", ""),
          (cart = await fetch("" + routes.cart_update_url, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ updates: updates, sections: sectionIds }),
          }).then(function (response) {
            return response.json();
          })),
          drawer.renderContents(cart),
          (document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate(),
            document.querySelector("cart-drawer-items") && document.querySelector("cart-drawer-items").onCartUpdate()));
      } catch (error) {
        console.error(error);
      } finally {
        (checkout && checkout.removeAttribute("disabled"), self._setGiftActionLoading(changeControl, !1, "change"));
      }
    })();
  }
}
class ProductOptions extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = { singleOptionSelector: "[js-product-option-selector]" }),
      (this._events = {
        change: "variant:change",
        fetchBefore: "variant:fetch:before",
        fetchAfter: "variant:fetch:after",
        fetchError: "variant:fetch:error",
      }));
  }
  connectedCallback() {
    var e;
    ((this._handle = this.dataset.productHandle),
      (this._masterSelect = document.getElementById(this.dataset.masterSelectId)),
      (this._checkAvailableOptions = !this.hasAttribute("data-disable-option-binding")),
      (this._optionSelectors = [...this.querySelectorAll(this._selectors.singleOptionSelector)]),
      this._checkAvailableOptions &&
      ((this._availableValues = {}),
        (this._lastSelectedOption = null),
        (this._option1Values = this._option2Values = null)),
      this.dataset.product &&
      (e = document.getElementById(this.dataset.product)) &&
      (this._product = (function (t) {
        try {
          var s = JSON.parse((t.textContent || t.innerHTML || "").trim());
          return Array.isArray(s && s.variants) ? s : null;
        } catch (r) {
          return null;
        }
      })(e)),
      this._product &&
      ((this._currentVariant = this._getVariantFromOptions()), this._checkAvailableOptions) &&
      this._setupOptionsAvailability(this._product),
      (this._product || this._handle) && this._setupListeners());
  }
  set product(e) {
    ((this._product = e), this.disconnectedCallback(), this.connectedCallback());
  }
  _setupListeners() {
    this._optionSelectors.forEach((e) => e.addEventListener("change", this._handleOptionChange));
  }
  _getVariantFromOptions() {
    if (this._product && Array.isArray(this._product.variants)) {
      let e = this._getCurrentOptions();
      var t = this._product.variants;
      return t.find((t) =>
        e.every((e) => {
          var o = t[e.index];
          return (
            o &&
            e.value ===
            String(o)
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
          );
        }),
      );
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((e) => {
        var t = e.getAttribute("type"),
          s = {};
        return (
          (("radio" !== t && "checkbox" !== t) || !!e.checked) && ((s.value = e.value), (s.index = e.dataset.index), s)
        );
      })
      .filter((e) => e);
  }
  _setupOptionsAvailability(e) {
    if (!e || !Array.isArray(e.variants)) return;
    ((this._option1Values = new Set()),
      (this._option2Values = new Set()),
      e.variants.forEach((e) => {
        var { option1: e, option2: t } = e;
        (e &&
          this._option1Values.add(
            e
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, ""),
          ),
          t &&
          this._option2Values.add(
            t
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, ""),
          ));
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      this._optionSelectors.forEach((e) => {
        null == this._lastSelectedOption &&
          e.checked &&
          (this._lastSelectedOption = { key: e.dataset.index, value: e.value });
      }),
      (this._availableValues = this._getAvailableValues(this._product, this._lastSelectedOption)),
      this._refreshValuesUI(this._availableValues));
  }
  _handleOptionChange = (t) => {
    this._product
      ? this._updateVariant(t)
      : this._fetchProduct(this._handle)
        .then((e) => {
          ((this._product = e),
            this._checkAvailableOptions && this._setupOptionsAvailability(this._product),
            this._updateVariant(t));
        })
        .catch((e) => console.log(e));
  };
  _updateVariant(e) {
    this._lastSelectedOption = { key: e.target.dataset.index, value: e.target.value };
    var t,
      s,
      r = this._getVariantFromOptions();
    (null == r &&
      this._product &&
      Array.isArray(this._product.variants) &&
      e.target &&
      e.target.dataset &&
      e.target.dataset.variantId &&
      (r = this._product.variants.find((t) => String(t.id) === String(e.target.dataset.variantId))),
      this.dispatchEvent(
        new CustomEvent(this._events.change, {
          detail: { variant: r, priceChange: this._hasPriceChanged(r) },
          bubbles: !0,
        }),
      ),
      this._checkAvailableOptions &&
      ((t = this._getAvailableValues(this._product, this._lastSelectedOption)),
        (s = this._getDifference(this._availableValues, t)),
        this._refreshValuesUI(s),
        (this._availableValues = t)),
      this.hasAttribute("data-enable-history-state") && this._updateHistoryState(r),
      this._masterSelect && this._updateMasterSelect(r),
      (this._currentVariant = r));
  }
  _hasPriceChanged(e) {
    return !(
      !e ||
      !this._currentVariant ||
      (e.price === this._currentVariant.price && e.compare_at_price === this._currentVariant.compare_at_price)
    );
  }
  _getAvailableValues(i, a) {
    if (!i || !Array.isArray(i.variants)) return {};
    if (a) {
      let s = {};
      var e = ["option1", "option2"],
        t = { option1: this._option1Values, option2: this._option2Values };
      let r = e.find((e) => e !== a.key);
      if (!r || !t[r]) return {};
      return (
        t[r].forEach((t) => {
          var e = i.variants.findIndex(
            (e) =>
              e[a.key]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === a.value &&
              e[r]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === t &&
              e.available,
          );
          s[t] = 0 <= e;
        }),
        s
      );
    }
    return i.variants.reduce((e, t) => {
      var { option1: t, option2: s } = t;
      return (t && (e[t] = !0), s && (e[s] = !0), e);
    }, {});
  }
  _refreshValuesUI(e) {
    for (var t in e) {
      var s = this.querySelector(`[value="${t}"]`);
      if (s && s.dataset.oos === "true") continue;
      s && (s.disabled = !e[t]);
    }
  }
  _updateHistoryState(e) {
    history.replaceState &&
      e &&
      ((e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id),
        window.history.replaceState({ path: e }, "", e));
  }
  _updateMasterSelect(e) {
    e && (this._masterSelect.value = e.id);
  }
  async _fetchProduct(e) {
    this.dispatchEvent(new CustomEvent(this._events.fetchBefore, { bubbles: !0 }));
    try {
      var t = await (await fetch(`/products/${e}.js`)).json();
      return (this.dispatchEvent(new CustomEvent(this._events.fetchAfter, { bubbles: !0 })), t);
    } catch (e) {
      this.dispatchEvent(new CustomEvent(this._events.fetchError, { details: { error: e }, bubbles: !0 }));
    }
  }
  _getDifference(e, t) {
    var s = {};
    if (e || t) {
      if (!e) return t;
      if (!t) return e;
      for (var r in t) t[r] !== e[r] && (s[r] = t[r]);
    }
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((e) => e.removeEventListener("change", this._handleOptionChange));
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))));
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    ("plus" === e.currentTarget.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
}
class LoadingSpinner extends HTMLElement {
  constructor() {
    super();
    var e = document.createElement("template");
    ((e.innerHTML = `
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `),
      this.attachShadow({ mode: "open" }),
      this.shadowRoot.appendChild(e.content.cloneNode(!0)));
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.predictiveSearchResults = this.querySelector("[js-predictive-search-results]")),
      (this.clearBtn = this.querySelector("[js-predictive-search-clear]")),
      document.addEventListener("SearchDrawer:open", () => {
        this.input.focus();
      }),
      this.input.addEventListener(
        "input",
        theme.utils
          .debounce((e) => {
            this.onChange(e);
          }, 300)
          .bind(this),
      ),
      this.clearBtn.addEventListener("click", this.clearSearch));
  }
  clearSearch = () => {
    var e = new Event("input", { bubbles: !0, cancelable: !0 });
    (this.input.dispatchEvent(e), this.input.focus());
  };
  onChange() {
    var e = this.input.value.trim();
    e.length
      ? (this.clearBtn.classList.remove("hidden"), this.getSearchResults(e))
      : (this.close(), this.clearBtn.classList.add("hidden"));
  }
  getSearchResults(e) {
    fetch(
      routes.predictive_search_url +
      `?q=${e}&resources[type]=product,collection,page&resources[limit]=10&section_id=predictive-search`,
    )
      .then((e) => {
        if (e.ok) return e.text();
        throw ((e = new Error(e.status)), this.close(), e);
      })
      .then((e) => {
        e = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        ((this.predictiveSearchResults.innerHTML = e), this.open());
      })
      .catch((e) => {
        throw (this.close(), e);
      });
  }
  open() {
    ((this.predictiveSearchResults.style.display = "block"), (this.predictiveSearchResults.scrollTop = 0));
  }
  close() {
    this.predictiveSearchResults.style.display = "none";
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        container: "filter-sort",
        form: "[js-filter-form]",
        filter: "[js-filter]",
        clearAll: "[js-clear-all]",
        loader: "loading-spinner",
      }),
      (this._events = { change: "filter:change" }),
      (this._cache = []),
      (this._debouncedOnSubmit = theme.utils.debounce((e) => {
        this._onSubmitHandler(e);
      }, 500)));
  }
  connectedCallback() {
    if (
      ((this._scope = this.dataset.scope),
        (this._form = this.querySelector(this._selectors.form)),
        (this._clearAll = this.querySelector(this._selectors.clearAll)),
        (this._loader = this.querySelector(this._selectors.loader)),
        this._setListeners(),
        !this._scope)
    )
      throw new Error("filter-sort must have scope set. See file for docs.");
  }
  _setListeners() {
    (window.addEventListener("popstate", this._onHistoryChange),
      this._form.addEventListener("input", this._debouncedOnSubmit),
      this._clearAll.addEventListener("click", this._onClearAllHandler),
      document.addEventListener("filter:change", this._onFilterChange),
      document.addEventListener("filter:clearAll", this._onClearAllHandler));
  }
  _renderComponent(e) {
    e =
      e.querySelector(`${this._selectors.container}[data-scope="${this._scope}"]`) ||
      e.querySelector(this._selectors.container);
    (theme.utils.refreshElements([this._selectors.filter], e, this),
      this.querySelectorAll("s-accordion").forEach((e) => {
        e.connectedCallback();
      }));
  }
  _onSubmitHandler = (e) => {
    e.preventDefault();
    ((e = new FormData(this._form)), (e = new URLSearchParams(e).toString()));
    this._propagateChange(e);
  };
  _onClearAllHandler = (e) => {
    e.preventDefault();
    this._propagateChange("");
  };
  _onFilterChange = (e) => {
    var { parsedHTML: e, scope: t } = e.detail;
    t !== this._scope && this._renderComponent(e);
  };
  _onHistoryChange = (e) => {
    e = e.state ? e.state.searchParams : FilterSort.searchParamsInitial;
    e !== FilterSort.searchParamsPrev && (this._propagateChange(e, !1), (this._onSubmitHandlerEvent = null));
  };
  async _propagateChange(e, t = !0) {
    this._loader.setAttribute("loading", "");
    let s = window.location.pathname + "?" + e;
    var r = (e) => e.url === s,
      r = this._cache.some(r) ? this._markupFromCache(r) : await this._markupFromFetch(s);
    (document.dispatchEvent(new CustomEvent("filter:change", { detail: { parsedHTML: r, scope: this._scope } })),
      this._renderComponent(r),
      t && history.pushState({ searchParams: e }, "", "" + window.location.pathname + (e && "?".concat(e))),
      this._loader.removeAttribute("loading", ""));
  }
  _markupFromCache(e) {
    e = this._cache.find(e).html;
    return new DOMParser().parseFromString(e, "text/html");
  }
  _markupFromFetch(s) {
    let r = this._cache;
    return fetch(s)
      .then((e) => e.text())
      .then((e) => {
        var t = new DOMParser().parseFromString(e, "text/html");
        return ((r = [...r, { html: e, url: s }]), t);
      });
  }
}
((FilterSort.searchParamsInitial = window.location.search.slice(1)),
  (FilterSort.searchParamsPrev = window.location.search.slice(1)));
class ActiveFilters extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = { remove: "[js-remove]", clearAll: "[js-clear-all]" }),
      (this._refresh = ["[js-active-filter]"]));
  }
  connectedCallback() {
    (document.addEventListener("filter:change", this._handleFilterChange), this._setListeners());
  }
  _setListeners() {
    var e = this.querySelector(this._selectors.clearAll);
    (e && e.addEventListener("click", this._triggerClearAll),
      this.querySelectorAll(this._selectors.remove).forEach((e) => e.addEventListener("click", this._handleRemove)));
  }
  _handleRemove = (e) => {
    e.preventDefault();
    var { name: e, value: t } = e.currentTarget.dataset,
      e = document.querySelector(`filter-sort [name="${e}"][value="${t}"]`);
    e && e.click();
  };
  _handleFilterChange = (e) => {
    ((e = e.detail.parsedHTML), (e = e.querySelector("active-filters")));
    ((this.innerHTML = e.innerHTML), this._setListeners());
  };
  _triggerClearAll = (e) => {
    (e.preventDefault(), e.stopImmediatePropagation(), document.dispatchEvent(new CustomEvent("filter:clearAll")));
  };
}
class PriceRange extends HTMLElement {
  constructor() {
    (super(),
      this.querySelectorAll("input").forEach((e) => e.addEventListener("change", this.onRangeChange.bind(this))),
      this.setMinAndMaxValues());
  }
  onRangeChange(e) {
    (this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues());
  }
  setMinAndMaxValues() {
    var e = this.querySelectorAll("input"),
      t = e[0],
      e = e[1];
    (e.value && t.setAttribute("max", e.value),
      t.value && e.setAttribute("min", t.value),
      "" === t.value && e.setAttribute("min", 0),
      "" === e.value && t.setAttribute("max", e.getAttribute("max")));
  }
  adjustToValidValues(e) {
    var t = Number(e.value),
      s = Number(e.getAttribute("min")),
      r = Number(e.getAttribute("max"));
    (t < s && (e.value = s), r < t && (e.value = r));
  }
}
class ProductCard extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        swatchesContainer: "[js-swatches-container]",
        swatchesTrigger: "[js-swatches-trigger]",
        swatchImage: "[js-swatch-image]",
        swatch: "[js-swatch]",
        badgeBestSeller: "[js-badge-best-seller]",
        badgeLimitedQuantities: "[js-badge-limited-quantities]",
      }));
  }
  connectedCallback() {
    ((this.swatchesContainer = this.querySelector(this._selectors.swatchesContainer)),
      (this.swatchesTrigger = this.querySelector(this._selectors.swatchesTrigger)),
      (this.swatchImages = this.querySelectorAll(this._selectors.swatchImage)),
      (this.swatches = this.querySelectorAll(this._selectors.swatch)),
      (this.badgeBestSeller = this.querySelector(this._selectors.badgeBestSeller)),
      (this.badgeLimitedQuantities = this.querySelector(this._selectors.badgeLimitedQuantities)),
      this._initListeners());
  }
  _initListeners() {
    (this.swatchesTrigger && this.swatchesTrigger.addEventListener("click", this._showSwatches),
      this.swatches &&
      this.swatches.forEach((e) => {
        (e.addEventListener("mouseover", this._setActiveSwatch),
          e.addEventListener("mouseout", this._resetActiveSwatch),
          e.addEventListener("focus", this._setActiveSwatch),
          e.addEventListener("blur", this._resetActiveSwatch),
          e.addEventListener("click", this._setActiveSwatch));
      }));
  }
  _showSwatches = (e) => {
    this.swatchesContainer.classList.add("active");
  };
  _setActiveSwatch = (e) => {
    e.currentTarget.dataset.swatch;
    this._resetSwatches();
    this._resetSwatchImages();
    const t = this._showSwatchImage(e);
    e.currentTarget.classList.add("active");
    this._applyBadgesFromSwatchImage(t);
  };
  _resetActiveSwatch = (e) => {
    (this.swatchImages.forEach((e) => {
      e.classList.contains("active--first") ? e.classList.add("active") : e.classList.remove("active");
    }),
      this.swatches.forEach((e) => {
        e.classList.contains("active--first") ? e.classList.add("active") : e.classList.remove("active");
      }));
    const t = Array.from(this.swatchImages || []).find((e) => e.classList.contains("active--first"));
    this._applyBadgesFromSwatchImage(t);
  };
  _showSwatchImage = (e) => {
    let t = e.currentTarget.dataset.swatch;
    let s = null;
    this.swatchImages.forEach((e) => {
      e.dataset.swatch == t && (e.classList.add("active"), s || (s = e));
    });
    return s;
  };
  _applyBadgesFromSwatchImage(e) {
    if (!e) return;
    const t = "1" === e.dataset.badgeBestSeller;
    const s = "1" === e.dataset.badgeLimitedQuantities;
    this.badgeBestSeller && this.badgeBestSeller.classList.toggle("hidden", !t);
    this.badgeLimitedQuantities && this.badgeLimitedQuantities.classList.toggle("hidden", !s);
    if (this.badgeLimitedQuantities) {
      const label = e.dataset.badgeLimitedLabel;
      if (label) {
        this.badgeLimitedQuantities.textContent = label;
      } else if (s) {
        this.badgeLimitedQuantities.textContent = "Low Stock";
      }
    }
  };
  _resetSwatchImages() {
    this.swatchImages &&
      this.swatchImages.forEach((e) => {
        e.classList.remove("active");
      });
  }
  _resetSwatches() {
    this.swatches &&
      this.swatches.forEach((e) => {
        e.classList.remove("active");
      });
  }
}
class QuickAdd extends HTMLElement {
  constructor() {
    (super(), (this._selectors = { addToCart: "[js-add-to-cart]", productOptions: "product-options", upsellPrice: "[js-upsell-price]", upsellImage: "[js-upsell-image]" }));
  }
  connectedCallback() {
    ((this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      (this.addToCart = this.querySelectorAll(this._selectors.addToCart)),
      this._setupListeners(),
      queueMicrotask(() => {
        this._setupUpsellVariantSync();
        theme.cartQuantityLimits &&
          theme.cartQuantityLimits.scheduleRefreshAtcState &&
          theme.cartQuantityLimits.scheduleRefreshAtcState();
      }));
  }
  disconnectedCallback() {
    this._upsellProductOptions &&
      this._upsellProductOptions.removeEventListener("variant:change", this._onUpsellVariantChange);
    this._upsellProductOptions = null;
  }
  _setupUpsellVariantSync() {
    (this._upsellProductOptions &&
      this._upsellProductOptions.removeEventListener("variant:change", this._onUpsellVariantChange),
      (this._upsellProductOptions = this.querySelector(this._selectors.productOptions)),
      this._upsellProductOptions &&
      this._upsellProductOptions.addEventListener("variant:change", this._onUpsellVariantChange));
  }
  _onUpsellVariantChange = (e) => {
    e.stopPropagation();
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    const formatMoney = window.theme && window.theme.utils && window.theme.utils.formatMoney;
    const variantPriceMapEl = this.querySelector('[id^="ProductVariantPriceMap-upsell-"]');
    let variantPriceMap = {};
    if (variantPriceMapEl) {
      try {
        variantPriceMap = JSON.parse(variantPriceMapEl.textContent || "{}");
      } catch (error) {
        variantPriceMap = {};
      }
    }
    const mappedPriceRow = variantPriceMap[String(variant.id)] || null;
    const effectivePrice = mappedPriceRow && typeof mappedPriceRow.price === "number" ? mappedPriceRow.price : variant.price;
    const effectiveCompareAtPrice = mappedPriceRow && typeof mappedPriceRow.compare_at_price === "number"
      ? mappedPriceRow.compare_at_price
      : variant.compare_at_price;
    const priceEl = this.querySelector(this._selectors.upsellPrice);
    if (priceEl) {
      const regular = priceEl.querySelector(".price__regular");
      const compare = priceEl.querySelector(".price__compare");
      if (regular) {
        regular.textContent = formatMoney ? formatMoney(effectivePrice) : "$" + (effectivePrice / 100).toFixed(2);
        const onSale = effectiveCompareAtPrice > effectivePrice;
        regular.classList.toggle("inline", onSale);
        regular.classList.toggle("text-red", onSale);
      }
      if (compare) {
        if (effectiveCompareAtPrice > effectivePrice) {
          compare.textContent = formatMoney
            ? formatMoney(effectiveCompareAtPrice)
            : "$" + (effectiveCompareAtPrice / 100).toFixed(2);
          compare.style.display = "";
        } else {
          compare.style.display = "none";
        }
      }
    }
    const atcBtn = this.querySelector(this._selectors.addToCart);
    const onSale = effectiveCompareAtPrice > effectivePrice;
    if (atcBtn) {
      (atcBtn.dataset.variantId = String(variant.id)),
        (atcBtn.dataset.variantOnSale = onSale ? "true" : "false"),
        (atcBtn.dataset.variantAvailable = variant.available ? "true" : "false");
    }
    theme.cartQuantityLimits &&
      theme.cartQuantityLimits.scheduleRefreshAtcState &&
      theme.cartQuantityLimits.scheduleRefreshAtcState();
    this.querySelectorAll("[js-color-label]").forEach((el) => {
      if (variant.option1) el.textContent = variant.option1;
    });
    this.querySelectorAll("[js-color-label-custom]").forEach((el) => {
      if (variant.option1) el.textContent = variant.option1;
    });
    const swatchLabels = this.querySelectorAll(".product__swatch-group .product__swatch");
    swatchLabels.forEach((label) => label.classList.remove("active"));
    const matchingRadio = this.querySelector(`.product__swatch-input[data-variant-id="${variant.id}"]`);
    if (matchingRadio) {
      matchingRadio.checked = true;
      const label = this.querySelector('label[for="' + matchingRadio.id + '"]');
      if (label) label.classList.add("active");
    }
    const imageEl = this.querySelector(this._selectors.upsellImage);
    if (imageEl) {
      const variantId = String(variant.id);
      const template = this.querySelector('template[data-variant-image="' + variantId + '"]');
      const img = imageEl.querySelector("img");
      if (img && template) {
        const src = template.getAttribute("data-image-src");
        const srcset = template.getAttribute("data-image-srcset");
        if (src) img.src = src;
        if (srcset) img.srcset = srcset;
      } else if (img && variant.featured_image && variant.featured_image.src) {
        img.src = variant.featured_image.src;
        img.srcset = variant.featured_image.src + " 1x";
        if (variant.featured_image.alt) {
          img.alt = theme.utils.stripProductMediaColorTag(variant.featured_image.alt);
        }
      }
    }
    const link = this.querySelector("a.product-upsell__image");
    if (link) {
      const url = new URL(link.href);
      url.searchParams.set("variant", variant.id);
      link.href = url.toString();
    }
  };
  _setupListeners() {
    this.addToCart.forEach((e) => {
      e.addEventListener("click", this._addToCart);
    });
  }
  _cartAdd(e, button) {
    fetch(
      (window.routes && window.routes.cart_add_url) ||
      window.Shopify.routes.root + "cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(e),
      },
    )
      .then((e) => e.json())
      .then((e) => {
        if (e.status) throw new Error(e.description || e.message || "Cart error");
        (document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate(),
          document.querySelector("cart-drawer-items") &&
          document.querySelector("cart-drawer-items").onCartUpdate(),
          this.cart && this.cart.renderContents(e),
          theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: "quick-add",
            productVariantId: e.items && e.items[0] ? String(e.items[0].variant_id) : void 0,
          }),
          this.cartDrawer &&
          "true" == this.cartDrawer.getAttribute("aria-hidden") &&
          this.cartDrawer.open());
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        if (button) {
          button.removeAttribute("disabled");
          const loader = button.querySelector("loading-spinner");
          if (loader) loader.removeAttribute("loading");
        }
      });
  }
  _addToCart = async (e) => {
    e.preventDefault();
    const button = e.currentTarget;
    button.setAttribute("disabled", "");
    const loader = button.querySelector("loading-spinner");
    if (loader) loader.setAttribute("loading", "");
    const release = () => {
      button.removeAttribute("disabled");
      loader && loader.removeAttribute("loading");
    };
    try {
      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();
      const cart = await (await fetch("" + routes.cart_url + ".js")).json(),
        i = "true" === button.dataset.variantOnSale,
        s = theme.cartQuantityLimits.canAddItems(cart, button.dataset.variantId, 1, i);
      if (!s.ok) {
        return (
          theme.cartQuantityLimits.showDrawerCartError(s.reason),
          void release()
        );
      }
      theme.cartQuantityLimits.clearDrawerCartError();
      this._cartAdd(
        {
          items: [{ id: button.dataset.variantId, quantity: 1 }],
          sections: this.cart.getSectionsToRender().map((e) => e.id),
          sections_url: window.location.pathname,
        },
        button
      );
    } catch (e) {
      (console.log(e), release());
    }
  };
}
class RecentlyViewed extends HTMLElement {
  constructor() {
    (super(), (this._selectors = { recentProducts: "[js-recent-products]" }));
  }
  connectedCallback() {
    ((this.recentProducts = this.querySelector(this._selectors.recentProducts)), this._initRecentProducts());
  }
  async _initRecentProducts() {
    var t = this.recentProducts,
      s = (new Array(), JSON.parse(localStorage.getItem("recently_viewed")));
    if (s) {
      var r,
        i = new Array(),
        a = window.location.pathname.includes("/products/"),
        o = a ? 5 : 4;
      let e;
      for (r of (e =
        a && 4 < s.length ? ((a = s.slice(-4)), (n = s[s.length - 5]), [...a, n]) : s.length > o ? s.slice(-o) : s))
        i.push(r.handle);
      var a = i.map((t) =>
        fetch(`/products/${t}/?view=product-card`)
          .then((e) => e.text())
          .then((e) => {
            e = new DOMParser().parseFromString(e, "text/html").querySelector("[js-product-card-copy]")?.innerHTML || "";
            return -1 == window.location.href.indexOf(t) && e !== "" ? `<div class="">${e}</div>` : null;
          }),
      ),
        n = (await Promise.all(a)).filter((e) => null !== e);
      0 < n.length && ((t.innerHTML = n.join("")), this.classList.remove("hidden"), this.classList.add("block"));
    }
  }
}
class ProductCompetitors extends HTMLElement {
  constructor() {
    (super(), (this._selectors = { tableHead: "[js-head]", tableRow: "[js-tr]", showMore: "[js-show-more]" }));
  }
  connectedCallback() {
    ((this.tableHead = this.querySelector(this._selectors.tableHead)),
      (this.tableRow = this.querySelectorAll(this._selectors.tableRow)),
      (this.showMore = this.querySelector(this._selectors.showMore)),
      this._fillInTable(),
      this._initListeners());
  }
  _initListeners() {
    this.showMore && this.showMore.addEventListener("click", this._showMore);
  }
  _fillInTable() {
    let r = this.tableHead.getElementsByTagName("th").length;
    this.tableRow.forEach((e) => {
      var t = e.getElementsByTagName("td").length;
      if (t != r) for (var s = r - t - 1; 0 <= s; s--) e.insertCell();
    });
  }
  _showMore = (e) => {
    var t = this.querySelectorAll("tr.hidden"),
      t =
        (Array.from(t)
          .slice(0, 10)
          .forEach((e) => {
            e.classList.remove("hidden");
          }),
          this.querySelectorAll("tr.hidden"));
    0 == Array.from(t).slice(0, 10).length && e.currentTarget.classList.add("hidden");
  };
}
class VideoModal extends HTMLElement {
  constructor() {
    (super(), (this._selectors = { video: "video", iframe: "iframe" }));
  }
  connectedCallback() {
    ((this.video = this.querySelector(this._selectors.video)),
      (this.iframe = this.querySelector(this._selectors.iframe)),
      (this.modalId = this.dataset.modalId),
      (this.modal = null),
      this.modalId
        ? ((this.modal = document.getElementById(this.modalId)),
          this.modal ? this.bindEvents() : console.warn("VideoModal: No modal found with ID " + this.modalId))
        : console.warn("VideoModal: No modal ID provided"));
  }
  bindEvents() {
    (this.modal.addEventListener("open", (e) => {
      this.playVideo();
    }),
      this.modal.addEventListener("close", (e) => {
        this.pauseVideo();
      }));
  }
  playVideo() {
    this.video &&
      ((this.video.currentTime = 0),
        this.video.play().catch((e) => {
          console.warn("VideoModal: Failed to play video:", e);
        }));
  }
  pauseVideo() {
    var e;
    this.video ? this.video.pause() : this.iframe && ((e = this.iframe.src), (this.iframe.src = e));
  }
  disconnectedCallback() {
    this.pauseVideo();
  }
}
class LuggageTagRegionGate extends HTMLElement {
  static STORAGE_KEY = "personalizedLuggageTagRegionPrompt";
  connectedCallback() {
    if (localStorage.getItem(LuggageTagRegionGate.STORAGE_KEY)) return;
    ((this.modal = document.getElementById(this.dataset.modalId)),
      this.modal &&
      ((this._choiceMade = !1),
        (this._usButton = this.modal.querySelector("[js-luggage-tag-region-us]")),
        (this._canadaButton = this.modal.querySelector("[js-luggage-tag-region-canada]")),
        this._usButton?.addEventListener("click", this._onUs),
        this._canadaButton?.addEventListener("click", this._onCanada),
        this.modal.addEventListener("close", this._onModalClose),
        requestAnimationFrame(() => this.modal.open())));
  }
  disconnectedCallback() {
    (this._usButton?.removeEventListener("click", this._onUs),
      this._canadaButton?.removeEventListener("click", this._onCanada),
      this.modal?.removeEventListener("close", this._onModalClose));
  }
  _onModalClose = () => {
    this._choiceMade ||
      requestAnimationFrame(() => {
        this.modal?.open();
      });
  };
  _onUs = () => {
    this._choiceMade = !0;
    localStorage.setItem(LuggageTagRegionGate.STORAGE_KEY, "us");
    var e = this.dataset.usDiscountCode?.trim();
    if (e) {
      var t = window.location.pathname + window.location.search,
        s = (window.Shopify?.routes?.root || "/").replace(/\/$/, "");
      window.location.href = `${s}/discount/${encodeURIComponent(e)}?redirect=${encodeURIComponent(t)}`;
    } else this.modal?.close();
  };
  _onCanada = () => {
    this._choiceMade = !0;
    localStorage.setItem(LuggageTagRegionGate.STORAGE_KEY, "ca");
    console.log("this.dataset.canadaStoreUrl", this.dataset.canadaStoreUrl);
    var e = this.dataset.canadaStoreUrl?.trim(),
      t = this.dataset.productPath;
    e && t ? (window.location.href = e.replace(/\/$/, "") + t) : console.warn("LuggageTagRegionGate: Canada store URL is not configured.");
  };
}
(customElements.define("s-drawer", Drawer),
  customElements.define("s-modal", Modal),
  customElements.define("s-accordion", Accordion),
  customElements.define("s-tabs", Tabs),
  customElements.define("s-carousel", Carousel),
  customElements.define("cart-remove-button", CartRemoveButton),
  customElements.define("cart-items", CartItems),
  customElements.define("cart-note", CartNote),
  customElements.define("cart-drawer", CartDrawer),
  customElements.define("cart-drawer-items", CartDrawerItems),
  customElements.define("threshold-free-gift", ThresholdFreeGift),
  customElements.define("s-header", SiteHeader),
  customElements.define("s-mobile-nav", MobileNav),
  customElements.define("product-options", ProductOptions),
  customElements.define("quantity-input", QuantityInput),
  customElements.define("loading-spinner", LoadingSpinner),
  customElements.define("predictive-search", PredictiveSearch),
  customElements.define("filter-sort", FilterSort),
  customElements.define("active-filters", ActiveFilters),
  customElements.define("price-range", PriceRange),
  customElements.define("product-card", ProductCard),
  customElements.define("quick-add", QuickAdd),
  customElements.define("recently-viewed", RecentlyViewed),
  customElements.define("product-competitors", ProductCompetitors),
  customElements.define("s-video-modal", VideoModal),
  theme.utils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
    scheduleSyncThresholdFreeGift();
    theme.cartQuantityLimits &&
      theme.cartQuantityLimits.scheduleRefreshAtcState &&
      theme.cartQuantityLimits.scheduleRefreshAtcState();
  }),
  "loading" === document.readyState
    ? document.addEventListener("DOMContentLoaded", function () {
      scheduleSyncThresholdFreeGift(!0);
      theme.cartQuantityLimits &&
        theme.cartQuantityLimits.scheduleRefreshAtcState &&
        theme.cartQuantityLimits.scheduleRefreshAtcState();
    })
    : (scheduleSyncThresholdFreeGift(!0),
      theme.cartQuantityLimits &&
      theme.cartQuantityLimits.scheduleRefreshAtcState &&
      theme.cartQuantityLimits.scheduleRefreshAtcState()));
class CollectionGrid extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        productGrid: "[js-products-grid]",
        productItem: ".collection-grid__product",
        sortTrigger: "[js-collection-sort-trigger]",
        nextPage: "[js-next-page]",
        loadingIcon: "[js-loading-icon]",
      }),
      (this._refresh = ["[js-products-grid]", "[js-pagination]"]),
      (this._maxEmptyPageFetches = 25),
      (this._cache = []));
  }
  connectedCallback() {
    ((this.productGrid = this.querySelector(this._selectors.productGrid)),
      (this.sortTrigger = this.querySelector(this._selectors.sortTrigger)),
      (this.loadingIcon = this.querySelector(this._selectors.loadingIcon)),
      this._setListeners(),
      this._retainHistory(),
      this._initInfiniteScroll(),
      this._scheduleContinueScroll());
  }
  disconnectedCallback() {
    this._scrollObserver && this._scrollObserver.disconnect();
  }
  _setListeners() {
    (document.addEventListener("filter:change", this._handleFilterChange),
      this.sortTrigger && this.sortTrigger.addEventListener("change", this._handleSortTrigger));
  }
  _initInfiniteScroll = () => {
    let sentinel = this.querySelector(this._selectors.nextPage);
    (this._scrollObserver && this._scrollObserver.disconnect(),
      sentinel &&
      ((this._scrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.isIntersecting && entry.target.dataset.url && this._addProducts(entry.target);
          });
        },
        { root: null, rootMargin: "0px 0px 320px 0px", threshold: 0 },
      )),
        this._scrollObserver.observe(sentinel)));
  };
  _scheduleContinueScroll = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this._maybeContinueScroll());
    });
  };
  _maybeContinueScroll = () => {
    let sentinel = this.querySelector(this._selectors.nextPage);
    if (!sentinel || !sentinel.dataset.url || sentinel.dataset.loading === "true") return;
    let rect = sentinel.getBoundingClientRect(),
      vh = window.innerHeight || document.documentElement.clientHeight;
    rect.top < vh + 400 && rect.bottom > -400 && this._addProducts(sentinel);
  };
  _retainHistory = () => {
    history.state && history.state.products && (this.productGrid.innerHTML = history.state.products);
  };
  _updateHistory(e, t, s) {
    let r = {};
    (((r = history.state ? history.state : r)[e] = t), s ? history.pushState(r, "", s) : history.pushState(r, ""));
  }
  _getProducts = (e) =>
    fetch(e)
      .then((e) => e.text())
      .then((e) => new DOMParser().parseFromString(e, "text/html"));
  _getSectionFromDoc(e) {
    return e.querySelector(`s-collection-grid[data-id="${this.dataset.id}"]`) || e.querySelector("s-collection-grid");
  }
  _countProductItems(e) {
    return e ? e.querySelectorAll(this._selectors.productItem).length : 0;
  }
  _extractProductItemsHtml(e) {
    var t = e.querySelector(this._selectors.productGrid);
    if (!t) return "";
    var s = t.querySelectorAll(this._selectors.productItem);
    return s.length ? Array.from(s).map((e) => e.outerHTML).join("") : "";
  }
  _initProductCards(e) {
    e.querySelectorAll("product-card").forEach((e) => {
      e.hasAttribute("data-initialized") || (e.setAttribute("data-initialized", "true"), e.connectedCallback());
    });
  }
  _addProducts = async (e, t = 0) => {
    if (!this.productGrid || !e || !e.dataset.url || e.dataset.loading === "true") return;
    e.dataset.loading = "true";
    var s = e.dataset.url,
      r = this._countProductItems(this.productGrid);
    try {
      var i = await this._getProducts(s),
        a = this._getSectionFromDoc(i),
        n = this._extractProductItemsHtml(a || i);
      (n && (this.productGrid.insertAdjacentHTML("beforeend", n), this._initProductCards(this.productGrid)),
        (a = (a || i).querySelector(this._selectors.nextPage)));
      var o = a && a.getAttribute("data-url"),
        l = this._countProductItems(this.productGrid) - r;
      if ((o ? e.setAttribute("data-url", o) : (e.remove(), this._scrollObserver && this._scrollObserver.disconnect()), 0 < l && this._updateHistory("products", this.productGrid.innerHTML, s), o && l === 0 && t < this._maxEmptyPageFetches))
        return (delete e.dataset.loading, this._addProducts(e, t + 1));
      this._scheduleContinueScroll();
    } catch (c) {
      console.warn(c);
    } finally {
      e.isConnected && delete e.dataset.loading;
    }
  };
  _handleFilterChange = (e) => {
    ((e = e.detail.parsedHTML), (e = e.querySelector(`[data-id="${this.dataset.id}"]`)));
    (theme.utils.refreshElements(this._refresh, e, this),
      (this.productGrid = this.querySelector(this._selectors.productGrid)),
      this._initInfiniteScroll(),
      this._scheduleContinueScroll());
  };
  _handleSortTrigger = (e) => {
    var value = e.currentTarget.value,
      sortSelect =
        document.querySelector(
          '#CollectionFiltersSidebar filter-sort[data-scope="sidebar"] [js-filter-form-sort]',
        ) || document.querySelector("[js-filter-form-sort]"),
      form =
        sortSelect?.closest("[js-filter-form]") || document.querySelector("[js-filter-form]");
    if (!sortSelect || !form) return;
    sortSelect.value = value;
    var hiddenSort = form.querySelector('input[type="hidden"][name="sort_by"]');
    hiddenSort && (hiddenSort.value = value);
    form.dispatchEvent(new Event("input", { bubbles: true }));
  };
}
class BlogGrid extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        articleGrid: "[js-blog-articles]",
        nextPage: "[js-next-page]",
      }));
  }
  connectedCallback() {
    ((this.articleGrid = this.querySelector(this._selectors.articleGrid)),
      this.articleGrid && this._initInfiniteScroll(),
      this._retainHistory());
  }
  disconnectedCallback() {
    this._scrollObserver && this._scrollObserver.disconnect();
  }
  _initInfiniteScroll = () => {
    let sentinel = this.querySelector(this._selectors.nextPage);
    if (!sentinel) return;
    this._scrollObserver && this._scrollObserver.disconnect();
    this._scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting && entry.target.dataset.url && this._addArticles(entry.target);
        });
      },
      { root: null, rootMargin: "0px 0px 320px 0px", threshold: 0 },
    );
    this._scrollObserver.observe(sentinel);
  };
  _maybeContinueBlogScroll = () => {
    let sentinel = this.querySelector(this._selectors.nextPage);
    if (!sentinel || !sentinel.dataset.url || sentinel.dataset.loading === "true") return;
    let rect = sentinel.getBoundingClientRect(),
      vh = window.innerHeight || document.documentElement.clientHeight,
      margin = 400;
    rect.top < vh + margin &&
      rect.bottom > -margin &&
      this._addArticles(sentinel);
  };
  _scheduleContinueBlogScroll = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this._maybeContinueBlogScroll());
    });
  };
  _retainHistory = () => {
    history.state && history.state.blogArticles && this.articleGrid && (this.articleGrid.innerHTML = history.state.blogArticles);
  };
  _updateHistory(e, t, s) {
    let r = {};
    (((r = history.state ? history.state : r)[e] = t), s ? history.pushState(r, "", s) : history.pushState(r, ""));
  }
  _getPage = (e) =>
    fetch(e).then((e) => {
      if (!e.ok) throw new Error("Blog fetch failed: " + e.status);
      return e.text();
    }).then((e) => new DOMParser().parseFromString(e, "text/html"));
  _addArticles = async (e) => {
    if (!this.articleGrid || !e.dataset.url || e.dataset.loading === "true") return;
    e.dataset.loading = "true";
    var url = e.dataset.url;
    try {
      let doc = await this._getPage(url),
        grid = doc.querySelector(this._selectors.articleGrid),
        inner = grid ? grid.innerHTML : "",
        nextEl = doc.querySelector(this._selectors.nextPage);
      (this.articleGrid.insertAdjacentHTML("beforeend", inner),
        this._updateHistory("blogArticles", this.articleGrid.innerHTML, url),
        nextEl ? e.setAttribute("data-url", nextEl.getAttribute("data-url")) : (e.remove(), this._scrollObserver && this._scrollObserver.disconnect()));
      this._scheduleContinueBlogScroll();
    } catch (err) {
      console.warn(err);
    } finally {
      e.isConnected && delete e.dataset.loading;
    }
  };
}
class ProductMain extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        sticky: "[js-sticky]",
        stickyAtc: "[js-sticky-atc]",
        mainAtc: "[js-main-add-to-cart]",
        carousel: "[js-carousel]",
        zoomModal: "[js-product-image-zoom-modal]",
        zoomTrigger: "[js-zoom-trigger]",
        videoModal: "[js-product-video-modal]",
        video: "[js-modal-video]",
        smoothScroll: "[js-smooth-scroll]",
        error: "[js-error-message]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        tagPreviewModal: "#TagPreviewModal",
        tagPreviewTextWrapper: "[js-tag-preview-text-wrapper]",
        tagPreviewAtc: "[js-tag-preview-atc]",
        tagInput: "[js-tag-customization-input]",
        tagError: " [js-tag-customization-error]",
        swatchLink: "[js-pdp-swatch-link]",
        keyFeatureDrawer: "#KeyFeaturesDrawer",
        keyFeatureBtn: "[js-open-key-features]",
      }));
  }
  connectedCallback() {
    ((this.buttons = this.querySelectorAll(this._selectors.addToCart)),
      (this.swatchLinks = this.querySelectorAll(this._selectors.swatchLink)),
      (this.keyFeatureBtn = this.querySelector(this._selectors.keyFeatureBtn)),
      (this.keyFeatureDrawer = document.querySelector(this._selectors.keyFeatureDrawer)),
      (this.smoothScroll = this.querySelector(this._selectors.smoothScroll)),
      (this.productId = this.dataset.productId),
      this._initProductForm(),
      this._handleSwatchLinks(),
      this._initZoomModal(),
      this._initVideoModal(),
      this._initStickyAtc(),
      this.addEventListener("variant:change", this._onVariantChange.bind(this)),
      "true" !== this.dataset.skipRecentlyViewed && this._initRecentlyViewed(),
      this._setInitialColorHandle(),
      this.smoothScroll &&
      this.smoothScroll.addEventListener("click", (e) => {
        ((e = e.currentTarget.dataset.id), (e = document.getElementById(e)));
        e && e.scrollIntoView({ behavior: "smooth", block: "start" });
      }));
    localStorage.recently_viewed;
    ((window.onpopstate = function (e) {
      location.reload();
    }),
      "true" == this.dataset.tagCustomization && this._handleTagCustomization(),
      this.keyFeatureBtn &&
      this.keyFeatureBtn.addEventListener("click", (e) => {
        (e.preventDefault(), e.stopImmediatePropagation(), this.keyFeatureDrawer.open());
      }),
      theme.utils.initPdpVariantFormSync(this),
      theme.cartQuantityLimits &&
      theme.cartQuantityLimits.scheduleRefreshAtcState &&
      theme.cartQuantityLimits.scheduleRefreshAtcState());
  }
  disconnectedCallback() {
    console.log("doc removed");
  }
  _setInitialColorHandle() {
    if (this.dataset.initialColorHandle !== undefined) {
      this._currentColorHandle = this.dataset.initialColorHandle || "";
      return;
    }
    const jsonId = this.dataset.jsonId || this.dataset.productJsonId || "ProductJSON";
    const productJson =
      this.querySelector(`script[type="application/json"]#${jsonId}`) || document.getElementById(jsonId);
    if (!productJson) {
      this._currentColorHandle = "";
      return;
    }
    try {
      const product = JSON.parse(productJson.textContent || "{}");
      if (!Array.isArray(product?.variants)) {
        this._currentColorHandle = "";
        return;
      }
      const idField = this.querySelector('[name="id"]');
      const initialVariant = product.variants.find((v) => String(v.id) === String(idField?.value));
      if (initialVariant?.option1) {
        this._currentColorHandle = initialVariant.option1
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      } else {
        this._currentColorHandle = "";
      }
    } catch (_error) {
      this._currentColorHandle = "";
    }
  }
  _renderNewProductPage = (s, r) => {
    fetch(s)
      .then((e) => e.text())
      .then((e) => {
        var e = new DOMParser().parseFromString(e, "text/html"),
          t = document.querySelector("#MainContent"),
          e = e.querySelector("#MainContent");
        ((t.innerHTML = e.innerHTML), !0 === r && window.history.pushState({}, "", s), this.remove());
      })
      .then(() => {
        (this._initYotpoWidgets(), theme.utils.initPdpVariantFormSync(document.querySelector("s-product")));
        theme.cartQuantityLimits &&
          theme.cartQuantityLimits.scheduleRefreshAtcState &&
          theme.cartQuantityLimits.scheduleRefreshAtcState();
      })
      .catch((e) => {
        console.error(e);
      });
  };
  _handleSwatchLinks = () => {
    this.swatchLinks.length < 1 ||
      this.swatchLinks.forEach((e) => {
        e.addEventListener("click", (e) => {
          e.preventDefault();
          e = e.currentTarget;
          e.classList.contains("active") || this._renderNewProductPage(e.href, !0);
        });
      });
  };
  _handleTagError = (e = !1) => {
    e
      ? ((this.tagError.innerHTML = e), this.tagError.classList.remove("hidden"))
      : this.tagError.classList.add("hidden");
  };
  _validateAddress = async (e) => {
    try {
      var t,
        s = "https://nominatim.openstreetmap.org/search?format=json&q=" + encodeURIComponent(e),
        r = await fetch(s, { method: "GET", headers: { "User-Agent": "SwissGear/1.0 analytics@seedcms.com" } });
      if (r.ok)
        return 0 === (t = await r.json()).length
          ? { success: !1, message: "Address not found." }
          : { success: !0, formattedAddress: t[0].display_name, latitude: t[0].lat, longitude: t[0].lon };
      throw new Error("API request failed with status " + r.status);
    } catch (e) {
      return { success: !1, message: "Error: " + e.message };
    }
  };
  _validateTagCustomization = async () => {
    var e,
      t,
      s,
      r = Array.from(this.tagInputs).reduce((e, t) => {
        switch (t.id) {
          case "LuggageTag-Name":
            e.name = t.value;
            break;
          case "LuggageTag-Address1":
            e.address1 = t.value;
            break;
          case "LuggageTag-Address2":
            e.address2 = t.value;
            break;
          case "LuggageTag-City":
            e.city = t.value;
            break;
          case "LuggageTag-State":
            e.state = t.value;
            break;
          case "LuggageTag-Zip":
            e.zip = t.value;
            break;
          case "LuggageTag-Phone":
            e.phone = t.value;
            break;
          case "LuggageTag-Email":
            e.email = t.value;
        }
        return e;
      }, {});
    return 0 == r.name
      ? { success: !1, message: "Name is required." }
      : 0 == r.address1 && 0 == r.phone && 0 == r.email
        ? { success: !1, message: "Address info or phone/email is required." }
        : (t = (e, t) => e.length > t)(r.name, 32)
          ? { success: !1, message: "Name field is too long." }
          : t(r.address1, 40)
            ? { success: !1, message: "Address line one field is too long." }
            : t(r.address2, 40)
              ? { success: !1, message: "Address line two field is too long." }
              : 40 < (r.city?.length || 0) + (r.zip?.length || 0) + 3
                ? { success: !1, message: "Address line three field is too long." }
                : t(r.phone, 40)
                  ? { success: !1, message: "Phone field is too long." }
                  : t(r.email, 40)
                    ? { success: !1, message: "Email field is too long." }
                    : i(r.name)
                      ? { success: !1, message: "Name field contains invalid characters." }
                      : i(r.address1)
                        ? { success: !1, message: "Address line one field contains invalid characters." }
                        : i(r.address2)
                          ? { success: !1, message: "Address line two field contains invalid characters." }
                          : (t = 0) <
                            (t = (t += 0 != r.city ? 1 : 0) + (0 != r.state ? 1 : 0) + (0 != r.zip ? 1 : 0)) &&
                            t < 3
                            ? { success: !1, message: "Address line three requires city, state and zip." }
                            : ((t = i(r.city)),
                              (s = i(r.state)),
                              (e = i(r.zip)),
                              t || s || e
                                ? { success: !1, message: "Address line three field contains invalid characters." }
                                : i(r.phone)
                                  ? { success: !1, message: "Phone field contains invalid characters." }
                                  : ((t = 0 != r.email && r.email?.indexOf("@") < 0),
                                    (s = i(r.email)),
                                    t || s
                                      ? { success: !1, message: "Email field must be a valid email address." }
                                      : { success: !0 }));
    function i(e) {
      return Array.from(e ?? "")
        .map((e) => e.codePointAt(0))
        .map(function (e) {
          return (32 <= e && e <= 126) || (161 <= e && e <= 172) || (174 <= e && e <= 255);
        })
        .includes(!1);
    }
  };
  _updateTagPreview = () => {
    (this.tagPreviewTextWrappers.forEach((t) => {
      ((t.innerHTML = ""),
        this.tagInputs.forEach((e) => {
          e.value.trim().length &&
            ((e = `<div class="tag-preview__text tag-preview__text--${e.id.replace("LuggageTag-", "").toLowerCase()}">${e.value.trim().toUpperCase()}</div>`),
              t.insertAdjacentHTML("beforeend", e));
        }));
    }),
      this.tagValidationPassed
        ? ((this.tagPreviewModal.dataset.confirmation = "true"), (this.tagValidationPassed = !1))
        : (this.tagPreviewModal.dataset.confirmation = "false"));
  };
  _handleTagCustomization() {
    ((this.tagPreviewModal = this.querySelector(this._selectors.tagPreviewModal)),
      (this.tagPreviewTextWrappers = this.tagPreviewModal.querySelectorAll(this._selectors.tagPreviewTextWrapper)),
      (this.tagPreviewAtc = this.tagPreviewModal.querySelector(this._selectors.tagPreviewAtc)),
      (this.tagInputs = this.querySelectorAll(this._selectors.tagInput)),
      (this.tagError = this.querySelector(this._selectors.tagError)),
      (this.tagValidationPassed = !1),
      this.tagPreviewModal.addEventListener("open", this._updateTagPreview),
      this.tagPreviewAtc.addEventListener("click", (e) => {
        (e.preventDefault(),
          (this.tagValidationPassed = !0),
          this.tagPreviewAtc.setAttribute("disabled", "disabled"),
          this.form.submit());
      }));
  }
  _initProductForm() {
    ((this.form = this.querySelector(this._selectors.form)),
      this.form &&
      (this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        (this.cart = document.querySelector("cart-drawer")),
        (this.cartDrawer = document.querySelector("#CartDrawer"))));
  }
  _initZoomModal() {
    ((this.zoomTriggers = this.querySelectorAll(this._selectors.zoomTrigger)),
      this.zoomTriggers.length < 1 ||
      ((this.imageZoomModal = this.querySelector(this._selectors.zoomModal)),
        (this.mainCarousel = this.querySelector(
          this._selectors.carousel + "#ProductMainImages-" + this.productId + (this.dataset.carouselIdSuffix || ""),
        )),
        (this.modalCarousel = this.imageZoomModal.querySelector(this._selectors.carousel)),
        this.zoomTriggers.forEach((e) => {
          e.addEventListener("click", this._openImageZoomModal.bind(this));
        }),
        1024 < window.innerWidth) ||
      (this.modalCarousel.swiper && this.modalCarousel.swiper.on("realIndexChange", () => {
        this.mainCarousel.swiper && this.mainCarousel.swiper.slideTo(this.modalCarousel.swiper.realIndex);
      })));
  }
  _initVideoModal() {
    ((this.videoModal = this.querySelector(this._selectors.videoModal)),
      this.videoModal &&
      (this.videoModal.addEventListener("close", this._pauseVideo),
        this.videoModal.addEventListener("open", this.playVideo)));
  }
  _initStickyAtc() {
    ((this.mainAtc = this.querySelector(this._selectors.mainAtc)),
      (this.sticky = this.querySelector(this._selectors.sticky)),
      (this.stickyAtc = this.querySelector(this._selectors.stickyAtc)));
    if (!this.sticky || !this.mainAtc || !this.stickyAtc) return;
    let t = this.sticky.offsetHeight,
      s = document.querySelector("#shopify-section-footer"),
      r = this.mainAtc,
      i = document.documentElement.style.getPropertyValue("--header-height").replace("px", "");
    (window.addEventListener("scroll", (e) => {
      r.getBoundingClientRect().top < i
        ? (this.sticky.classList.add("show"), (s.style.paddingBottom = t + "px"))
        : (this.sticky.classList.remove("show"), (s.style.paddingBottom = "0px"));
    }),
      this.stickyAtc.addEventListener("click", (e) => {
        (e.preventDefault(),
          "true" == e.currentTarget.dataset.chooseSize
            ? window.scrollTo({ top: 0, behavior: "smooth" })
            : this.mainAtc.click());
      }));
  }
  _onVariantChange(e) {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    this.handleErrorMessage();
    this.error = false;
    const formatMoney = window.theme && window.theme.utils && window.theme.utils.formatMoney;
    const variantPriceMapEl =
      this.querySelector("#ProductVariantPriceMap") ||
      this.querySelector('[id^="ProductVariantPriceMap-qv-"]') ||
      this.querySelector('[id^="ProductVariantPriceMap-upsell-"]');
    let variantPriceMap = {};
    if (variantPriceMapEl) {
      try {
        variantPriceMap = JSON.parse(variantPriceMapEl.textContent || "{}");
      } catch (error) {
        variantPriceMap = {};
      }
    }
    const mappedPriceRow = variantPriceMap[String(variant.id)] || null;
    const effectivePrice = mappedPriceRow && typeof mappedPriceRow.price === "number" ? mappedPriceRow.price : variant.price;
    const effectiveCompareAtPrice = mappedPriceRow && typeof mappedPriceRow.compare_at_price === "number"
      ? mappedPriceRow.compare_at_price
      : variant.compare_at_price;
    const priceEls = this.querySelectorAll("[js-price]");
    priceEls.forEach((el) => {
      const regular = el.querySelector(".price__regular");
      const compare = el.querySelector(".price__compare");
      if (regular) {
        regular.textContent = formatMoney ? formatMoney(effectivePrice) : "$" + (effectivePrice / 100).toFixed(2);
        const onSale = effectiveCompareAtPrice > effectivePrice;
        regular.classList.toggle("inline", onSale);
        regular.classList.toggle("text-red", onSale);
      }
      if (compare) {
        if (effectiveCompareAtPrice > effectivePrice) {
          compare.textContent = formatMoney
            ? formatMoney(effectiveCompareAtPrice)
            : "$" + (effectiveCompareAtPrice / 100).toFixed(2);
          compare.style.display = "";
        } else {
          compare.style.display = "none";
        }
      }
    });
    this.querySelectorAll("[js-color-label]").forEach((el) => {
      if (el.closest("quick-add")) return;
      if (variant.option1) el.textContent = variant.option1;
    });
    this.querySelectorAll("[js-color-label-custom]").forEach((el) => {
      if (el.closest("quick-add")) return;
      if (variant.option1) el.textContent = variant.option1;
    });
    const swatchLabels = this.querySelectorAll(".product__swatch-group .product__swatch");
    swatchLabels.forEach((label) => {
      if (label.closest("quick-add")) return;
      label.classList.remove("active");
    });
    const checkedInput = this.querySelector(".product__swatch-input:checked:not(quick-add .product__swatch-input)");
    if (checkedInput) {
      const activeLabel = checkedInput.nextElementSibling;
      if (activeLabel && activeLabel.classList.contains("product__swatch")) activeLabel.classList.add("active");
    }
    const onSaleForAtc = effectiveCompareAtPrice > effectivePrice;
    this.querySelectorAll(this._selectors.addToCart).forEach((btn) => {
      if (btn.closest("quick-add")) return;
      (btn.dataset.variantId = String(variant.id)),
        (btn.dataset.variantOnSale = onSaleForAtc ? "true" : "false"),
        (btn.dataset.variantAvailable = variant.available ? "true" : "false");
    });
    theme.cartQuantityLimits &&
      theme.cartQuantityLimits.scheduleRefreshAtcState &&
      theme.cartQuantityLimits.scheduleRefreshAtcState();
    const filterGallery = this.dataset.filterGalleryByColor === "true";
    if (!filterGallery) {
      const suffix = this.dataset.carouselIdSuffix || "";
      const mainCarousel = this.querySelector(this._selectors.carousel + "#ProductMainImages-" + this.productId + suffix);
      if (mainCarousel && mainCarousel.swiper && variant.featured_media && variant.featured_media.position) {
        const slideIndex = Math.max(0, variant.featured_media.position - 1);
        mainCarousel.swiper.slideTo(slideIndex, 300);
      }
    }
    if (this.mainAtc) {
      this.mainAtc.disabled = !variant.available;
      const mainAtcText = this.mainAtc.querySelector("[js-atc-text]");
      if (mainAtcText) mainAtcText.textContent = variant.available ? " Add To Cart " : " Sold Out ";
      else this.mainAtc.textContent = variant.available ? " Add To Cart " : " Sold Out ";
    }
    const stickyAtc = this.querySelector(this._selectors.stickyAtc);
    if (stickyAtc && !stickyAtc.dataset.chooseSize) {
      const stickyAtcText = stickyAtc.querySelector("[js-atc-text]");
      if (stickyAtcText) stickyAtcText.textContent = variant.available ? "Add to Cart" : "Sold Out";
      else stickyAtc.textContent = variant.available ? "Add to Cart" : "Sold Out";
    }
    const prevColor = this._currentColorHandle;
    const newColor = variant.option1 ? variant.option1.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "") : "";
    if (filterGallery && newColor !== prevColor) {
      this._filterGalleryByColor(newColor);
    }
    this._currentColorHandle = newColor;
    this._syncSizeLinksToColor(newColor);
    this._updateAccordionFromTemplate(variant.id);
    this._updateStickyImage(variant.id);
    this._updateKeyFeaturesDrawer(variant.id);
  }
  _syncSizeLinksToColor(colorHandle) {
    const mapEl = this.querySelector("[js-size-color-variant-map]");
    if (!mapEl) return;
    let map;
    try {
      map = JSON.parse(mapEl.textContent || "{}");
    } catch {
      return;
    }
    this.querySelectorAll(".sizes-swatches [js-pdp-swatch-link][data-size-key]").forEach((link) => {
      const base = link.dataset.baseUrl || link.getAttribute("href").split("?")[0];
      const variantId = map[link.dataset.sizeKey] && map[link.dataset.sizeKey][colorHandle];
      link.setAttribute("href", variantId ? base + "?variant=" + variantId : base);
    });
  }
  _filterGalleryByColor(colorHandle) {
    const suffix = this.dataset.carouselIdSuffix || "";
    const carouselIds = suffix
      ? ["ProductMainImages-" + this.productId + suffix]
      : ["ProductThumbImages-" + this.productId, "ProductMainImages-" + this.productId, "ProductModalCarousel-" + this.productId];
    carouselIds.forEach((id) => {
      const carouselEl = document.getElementById(id);
      if (!carouselEl || !carouselEl.swiper) return;
      const wrapper = carouselEl.querySelector(".swiper-wrapper");
      const pool = carouselEl.querySelector(".color-slides-pool");
      if (!wrapper || !pool) return;
      while (wrapper.firstElementChild) {
        pool.appendChild(wrapper.firstElementChild);
      }
      const matching = pool.querySelectorAll(`[data-color-handle="${colorHandle}"], [data-color-handle=""]`);
      matching.forEach((slide) => {
        wrapper.appendChild(slide);
      });
      carouselEl.swiper.update();
      carouselEl.swiper.slideTo(0, 0);
    });
  }
  _updateAccordionFromTemplate(variantId) {
    const featTmpl = this.querySelector(`template[data-variant-features="${variantId}"]`);
    const specsTmpl = this.querySelector(`template[data-variant-specs="${variantId}"]`);
    const featAccordion = this.querySelector("[js-additional-features-accordion]");
    const specsAccordion = this.querySelector("[js-technical-specs-accordion]");

    const getTemplateHtml = (tmpl) => {
      if (!tmpl?.content) return "";
      const el = tmpl.content.firstElementChild;
      if (el?.innerHTML) return el.innerHTML;
      if (tmpl.content.childNodes.length) {
        return Array.from(tmpl.content.childNodes).map((n) => n.outerHTML || n.textContent || "").join("");
      }
      return "";
    };

    const hasContent = (html) => html && html.trim().length > 0;

    if (featAccordion) {
      const featContent = featAccordion.querySelector("[js-additional-features-content]");
      const templateHtml = getTemplateHtml(featTmpl);
      if (featContent && templateHtml) {
        featContent.innerHTML = templateHtml;
      }
      const showAccordion = hasContent(templateHtml) || (featContent && hasContent(featContent.innerHTML));
      featAccordion.classList.toggle("hidden", !showAccordion);
    }
    if (specsAccordion) {
      const specsContent = specsAccordion.querySelector("[js-technical-specs-content]");
      const templateHtml = getTemplateHtml(specsTmpl);
      if (specsContent && templateHtml) {
        specsContent.innerHTML = templateHtml;
      }
      const showAccordion = hasContent(templateHtml) || (specsContent && hasContent(specsContent.innerHTML));
      specsAccordion.classList.toggle("hidden", !showAccordion);
    }
  }
  _updateStickyImage(variantId) {
    const tmpl = this.querySelector(`template[data-variant-sticky-image="${variantId}"]`);
    const stickyEl = this.querySelector("[js-sticky-image]");
    if (tmpl?.content?.firstElementChild && stickyEl) {
      stickyEl.innerHTML = tmpl.content.firstElementChild.outerHTML;
    }
  }
  _updateKeyFeaturesDrawer(variantId) {
    if (!this.keyFeatureDrawer) return;
    const tmpl = this.keyFeatureDrawer.querySelector(`template[data-variant-key-features="${variantId}"]`);
    const listEl = this.keyFeatureDrawer.querySelector("[js-key-features-list]");
    if (listEl && tmpl?.content?.firstElementChild) {
      listEl.innerHTML = tmpl.content.firstElementChild.innerHTML;
    }
  }
  _initRecentlyViewed() {
    if ("true" === this.dataset.skipRecentlyViewed) return;
    const jsonId = this.dataset.productJsonId || "ProductJSON";
    var r = document.getElementById(jsonId);
    if (r) {
      var r = { handle: JSON.parse(r.innerHTML).handle },
        i = [];
      i.push(r);
      let e, t, s;
      var r = r.handle,
        a = JSON.stringify(i),
        o = localStorage.getItem("recently_viewed");
      null == o
        ? localStorage.setItem("recently_viewed", a)
        : null != o &&
        ((o = ((a = localStorage.getItem("recently_viewed")).match(/handle/g) || []).length),
          (r = a.includes(r)),
          o < 5 && 0 == r
            ? ((e = JSON.parse(a)),
              (t = [...i, ...e]),
              (s = JSON.stringify(t)),
              localStorage.setItem("recently_viewed", s))
            : 5 <= o &&
            0 == r &&
            ((e = JSON.parse(a)).pop(),
              (t = [...i, ...e]),
              (s = JSON.stringify(t)),
              localStorage.setItem("recently_viewed", s)));
    }
  }
  _initYotpoWidgets() {
    yotpoWidgetsContainer.initWidgets();
  }
  async _abortIfCartQuantityLimits() {
    if (!theme.cartQuantityLimits || !this.form) return !1;
    ((this.cart = document.querySelector("cart-drawer") || this.cart),
      (this.cartDrawer = document.getElementById("CartDrawer") || this.cartDrawer));
    var s = new FormData(this.form),
      t = s.get("id");
    if (!t) return !1;
    var r,
      i = s.get("quantity") || 1,
      a = [{ id: t, quantity: i }],
      o = s.get("properties[_auto_gwp]");
    o &&
      ((r = JSON.parse(o).map((e) => ({ id: e, quantity: 1, properties: { _auto_gwp_free_gift: t } }))), a.push(...r));
    var cfg = theme.cartQuantityLimits.getConfig(),
      cartData = await (await fetch("" + routes.cart_url + ".js")).json(),
      mainQty = parseInt(String(i), 10) || 1,
      totalDelta = a.reduce(function (e, t) {
        return e + (parseInt(String(t.quantity), 10) || 0);
      }, 0);
    let isSale = !1;
    const priceMapEl =
      this.querySelector("#ProductVariantPriceMap") ||
      this.querySelector('[id^="ProductVariantPriceMap-qv-"]') ||
      this.querySelector('[id^="ProductVariantPriceMap-upsell-"]') ||
      document.getElementById("ProductVariantPriceMap");
    if (priceMapEl)
      try {
        var pm = JSON.parse(priceMapEl.textContent || "{}"),
          prow = pm[String(t)];
        prow &&
          "number" == typeof prow.compare_at_price &&
          "number" == typeof prow.price &&
          prow.compare_at_price > prow.price &&
          (isSale = !0);
      } catch (e) {
        void 0;
      }
    if (!isSale) {
      const pj = document.getElementById(this.dataset.productJsonId || "ProductJSON");
      if (pj)
        try {
          const variants = JSON.parse(pj.textContent || "{}").variants || [];
          var v = variants.find((e) => String(e.id) === String(t));
          v &&
            !isNaN(Number(v.compare_at_price)) &&
            !isNaN(Number(v.price)) &&
            Number(v.compare_at_price) > Number(v.price) &&
            (isSale = !0);
        } catch (e) {
          void 0;
        }
    }
    if (cartData.item_count + totalDelta > cfg.cartTotalMax) {
      var limitMsg = theme.cartQuantityLimits.getAddBlockedMessage("total"),
        qvModalLimit = this.closest("s-modal.quick-view-modal");
      return (
        this._enableButtons(),
        theme.cartQuantityLimits.showDrawerCartError("total"),
        this.cartDrawer?.open?.(),
        this.handleErrorMessage(limitMsg),
        qvModalLimit && "function" == typeof qvModalLimit.close && qvModalLimit.close(),
        (this.error = !0),
        this.tagPreviewAtc && ((this.tagPreviewAtc.disabled = !1), this.tagPreviewAtc.removeAttribute("disabled")),
        !0
      );
    }
    if (isSale && theme.cartQuantityLimits.saleQtyInCart(cartData) + mainQty > cfg.saleLineMax) {
      var saleLimitMsg = theme.cartQuantityLimits.getAddBlockedMessage("sale"),
        qvModalSale = this.closest("s-modal.quick-view-modal");
      return (
        this._enableButtons(),
        theme.cartQuantityLimits.showDrawerCartError("sale"),
        this.cartDrawer?.open?.(),
        this.handleErrorMessage(saleLimitMsg),
        qvModalSale && "function" == typeof qvModalSale.close && qvModalSale.close(),
        (this.error = !0),
        this.tagPreviewAtc && ((this.tagPreviewAtc.disabled = !1), this.tagPreviewAtc.removeAttribute("disabled")),
        !0
      );
    }
    return !1;
  }
  async onSubmitHandler(e) {
    (e.preventDefault(), this.handleErrorMessage(), this._disableButtons());
    if ("true" == this.dataset.tagCustomization && !this.tagValidationPassed) {
      if (await this._abortIfCartQuantityLimits()) return;
      return (
        this._handleTagError(!1),
        (e = await this._validateTagCustomization()).success
          ? ((this.tagValidationPassed = !0), this.tagPreviewModal.open())
          : ((this.tagValidationPassed = !1), this._handleTagError(e.message)),
        void this._enableButtons()
      );
    }
    try {
      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();
      ((this.cart = document.querySelector("cart-drawer") || this.cart),
        (this.cartDrawer = document.getElementById("CartDrawer") || this.cartDrawer));
      if (await this._abortIfCartQuantityLimits()) return;
      var s = new FormData(this.form);
      let t = s.get("id");
      var r,
        i = s.get("quantity") || 1,
        a = [{ id: t, quantity: i }],
        o = s.get("properties[_auto_gwp]");
      o &&
        ((r = JSON.parse(o).map((e) => ({ id: e, quantity: 1, properties: { _auto_gwp_free_gift: t } }))),
          a.push(...r));
      theme.cartQuantityLimits.clearDrawerCartError();
      var n = await (
        await fetch("" + window.routes.cart_add_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: a,
            sections: this.cart.getSectionsToRender().map((e) => e.id),
            sections_url: window.location.pathname,
          }),
        })
      ).json();
      n.status
        ? (theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: t,
          errors: n.errors || n.description,
          message: n.message,
        }),
          this.handleErrorMessage(n.description),
          (this.error = !0))
        : this.cart
          ? this.error ||
          (theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: t,
          }),
            (this.error = !1),
            this.cart.renderContents(n),
            this.cartDrawer.open())
          : (window.location = window.routes.cart_url);
    } catch (e) {
      (this.handleErrorMessage(e.description), console.error(e));
    } finally {
      this._enableButtons();
    }
  }
  handleErrorMessage(e = !1) {
    ((this.errorMessageWrapper = this.querySelector(this._selectors.error)),
      this.errorMessageWrapper &&
      (e
        ? ((this.errorMessageWrapper.innerHTML = e), this.errorMessageWrapper.classList.remove("hidden"))
        : this.errorMessageWrapper.classList.add("hidden")));
  }
  _disableButtons() {
    this.querySelectorAll(this._selectors.addToCart).forEach((e) => {
      ((e.disabled = !0), e.setAttribute("disabled", ""));
      e = e.querySelector(this._selectors.loader);
      e && e.setAttribute("loading", "");
    });
  }
  _enableButtons() {
    this.querySelectorAll(this._selectors.addToCart).forEach((e) => {
      ((e.disabled = !1), e.removeAttribute("disabled"), e.removeAttribute("aria-disabled"));
      e = e.querySelector(this._selectors.loader);
      e && e.removeAttribute("loading");
    });
  }
  _openImageZoomModal = (e) => {
    (e.preventDefault(),
      e.stopImmediatePropagation(),
      this.imageZoomModal.open(),
      this.modalCarousel.swiper.slideTo(this.mainCarousel.swiper.realIndex, 0, !1));
  };
  _pauseVideo = (t) => {
    t = t.target.querySelector(this._selectors.video);
    if (t) {
      let e = t.getAttribute("src");
      ((e = e.replace("&autoplay=1", "")), t.setAttribute("src", ""), t.setAttribute("src", e));
    }
  };
  playVideo = (e) => {
    var t,
      e = e.target.querySelector(this._selectors.video);
    e && ((t = e.getAttribute("src")), (t += "&autoplay=1"), e.setAttribute("src", ""), e.setAttribute("src", t));
  };
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    new IntersectionObserver(
      ((e, t) => {
        e[0].isIntersecting &&
          (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                var t = document.createElement("div"),
                  e = ((t.innerHTML = e), t.querySelector("product-recommendations"));
                e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML);
              })
              .catch((e) => {
                console.error(e);
              }));
      }).bind(this),
      { rootMargin: "0px 0px 200px 0px" },
    ).observe(this);
  }
}
class LabelHelp extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        carousel: "[js-carousel]",
        trigger: "[js-label-help-trigger]",
        triggerContent: "[js-label-help-trigger-content]",
        video: "[js-label-help-video]",
      }));
  }
  connectedCallback() {
    ((this.swiper = this.querySelector(this._selectors.carousel).swiper),
      (this.triggers = this.querySelectorAll(this._selectors.trigger)),
      (this.video = this.querySelector(this._selectors.video)),
      this._setListeners());
  }
  _setListeners() {
    (this.swiper && this.swiper.on("slideChange", this._slideOnChange),
      this.triggers.forEach((e) => {
        e.addEventListener("click", this._triggerOnClick);
      }));
  }
  _slideOnChange = () => {
    var e;
    1024 <= window.innerWidth ||
      ((e = this.querySelector(`${this._selectors.triggerContent}[data-index="${this.swiper.activeIndex}"]`)),
        this._toggleTriggerContent(e));
  };
  _triggerOnClick = (e) => {
    var t;
    (e.preventDefault(),
      window.innerWidth < 1024 ||
      ((t = (e = e.currentTarget).dataset.index),
        "true" != (t = this.querySelector(this._selectors.triggerContent + `[data-index="${t}"]`)).dataset.active &&
        (e.blur(), this._toggleTriggerContent(t))));
  };
  _toggleTriggerContent = (e) => {
    var t = this.querySelector(this._selectors.triggerContent + '[data-active="true"]');
    (t && (t.dataset.active = "false"), (e.dataset.active = "true"), this.video && this._resetVideoPlay());
  };
  _resetVideoPlay = () => {
    (this.video.pause(), (this.video.currentTime = 0), this.video.play());
  };
}
(customElements.define("s-collection-grid", CollectionGrid),
  customElements.define("s-blog-grid", BlogGrid),
  customElements.define("s-product", ProductMain),
  customElements.define("luggage-tag-region-gate", LuggageTagRegionGate),
  customElements.define("product-recommendations", ProductRecommendations),
  customElements.define("label-help", LabelHelp));
class Account extends HTMLElement {
  constructor() {
    (super(),
      (this._selectors = {
        addressCountrySelect: "[js-country-select]",
        editAddressModal: "[js-edit-address-modal]",
        editAddressOpen: "[js-edit-address]",
        editAddressForm: "[js-edit-address-form]",
        deleteAddressButton: "[js-delete-address]",
        ordersContainer: "[js-orders]",
        ordersPagination: "[js-next-page]",
        order: "[js-order]",
      }));
  }
  connectedCallback() {
    ((this.countrySelects = this.querySelectorAll(this._selectors.addressCountrySelect)),
      (this.editAddressModal = this.querySelector(this._selectors.editAddressModal)),
      (this.openEditAddress = this.querySelectorAll(this._selectors.editAddressOpen)),
      (this.editAddressForms = this.querySelectorAll(this._selectors.editAddressForm)),
      (this.deleteAddressButtons = this.querySelectorAll(this._selectors.deleteAddressButton)),
      (this.ordersContainer = this.querySelector(this._selectors.ordersContainer)),
      (this.ordersPagination = this.querySelector(this._selectors.ordersPagination)),
      this._setupCountries(),
      this._setupEventListeners());
  }
  _setupCountries() {
    Shopify &&
      Shopify.CountryProvinceSelector &&
      (new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
        hideElement: "AddressProvinceContainerNew",
      }),
        this.countrySelects.forEach((e) => {
          e = e.dataset.formId;
          new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, {
            hideElement: "AddressProvinceContainer_" + e,
          });
        }));
  }
  _setupEventListeners() {
    (this.ordersPagination && this.ordersPagination.addEventListener("click", this._addOrders),
      this.openEditAddress.forEach((e) => {
        e.addEventListener("click", this._handleOpenEditAddress);
      }),
      this.deleteAddressButtons.forEach((e) => {
        e.addEventListener("click", this._handleDeleteAddress);
      }),
      this.editAddressModal.addEventListener("close", this._handleCloseEditAddress));
  }
  _addOrders = async () => {
    var e = this.ordersPagination.dataset.url,
      e = await this._getOrders(e),
      t = e.querySelector(this._selectors.ordersContainer).innerHTML,
      e = e.querySelector(this._selectors.ordersPagination);
    (this.ordersContainer.insertAdjacentHTML("beforeend", t),
      e ? (this.ordersPagination.dataset.url = e.dataset.url) : this.ordersPagination.remove(),
      this.ordersContainer.connectedCallback());
  };
  _getOrders(e) {
    return fetch(e)
      .then((e) => e.text())
      .then((e) => new DOMParser().parseFromString(e, "text/html"));
  }
  _handleOpenEditAddress = (e) => {
    e.stopPropagation();
    ((e = e.currentTarget.dataset.form), (e = document.querySelector("#address_form_" + e)));
    (e.classList.remove("hidden"),
      this.editAddressModal.open(),
      e.querySelector('[name="address[first_name]"]').focus());
  };
  _handleDeleteAddress = (e) => {
    e = e.currentTarget.dataset.target;
    confirm("Are you sure you want to delete this address?") &&
      Shopify.postLink(e, { parameters: { _method: "delete" } });
  };
  _handleCloseEditAddress = (e) => {
    this.editAddressForms.forEach((e) => {
      e.classList.add("hidden");
    });
  };
}
customElements.define("s-account", Account);
(function () {
  var e, t, s, r;
  try {
    e = new URLSearchParams(window.location.search);
  } catch (l) {
    return;
  }
  function i() {
    var e = document.querySelector("#CartDrawer");
    e && "function" == typeof e.open && e.open();
  }
  function a(e) {
    "complete" === document.readyState ? e() : window.addEventListener("DOMContentLoaded", e, { once: !0 });
  }
  function o(e) {
    if (!e || "string" != typeof e) return [];
    for (var t = {}, s = [], r = e.split(","), i = 0; i < r.length && s.length < 4; i++) {
      var a = parseInt(String(r[i]).trim(), 10);
      if (!(a > 0) || !isFinite(a) || t[a]) continue;
      ((t[a] = !0), s.push(a));
    }
    return s;
  }
  function u() {
    try {
      var e = new URL(window.location.href);
      if (!e.searchParams.has("add_to_cart") && !e.searchParams.has("cart_opened")) return;
      (e.searchParams.delete("add_to_cart"),
        e.searchParams.delete("cart_opened"),
        history.replaceState({}, "", e.pathname + (e.search || "") + e.hash));
    } catch (t) { }
  }
  if (((t = e.get("add_to_cart")), (s = "true" === e.get("cart_opened")), (r = o(t)), r.length)) {
    a(function () {
      var e = document.querySelector("cart-drawer"),
        t =
          (window.routes && window.routes.cart_add_url) ||
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + "cart/add.js");
      if (!e || "function" != typeof e.getSectionsToRender) return (s && i(), void u());
      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();
      var n = r.map(function (e) {
        return { id: e, quantity: 1 };
      }),
        c = e
          .getSectionsToRender()
          .map(function (e) {
            return e.id;
          });
      fetch("" + t, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items: n, sections: c, sections_url: window.location.pathname }),
      })
        .then(function (e) {
          return e.json();
        })
        .then(function (t) {
          return t && t.status
            ? (theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
              source: "url-params-add-to-cart",
              errors: t.errors || t.description,
              message: t.message,
            }),
              s && i(),
              void u())
            : "Cart Error" === t.message
              ? (s && i(), void u())
              : (document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate(),
                document.querySelector("cart-drawer-items") &&
                document.querySelector("cart-drawer-items").onCartUpdate(),
                e.renderContents(t),
                theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                  source: "url-params-add-to-cart",
                }),
                i(),
                void u());
        })
        .catch(function (e) {
          (console.warn(e), s && i(), u());
        });
    });
    return;
  }
  s &&
    a(function () {
      (i(), u());
    });
})();
